export const PFDuos = [
  {
    char: 'trailblazer-remembrance',
    app: 68.84,
    char_1: 'castorice',
    app_rate_1: '70.1%',
    avg_round_1: 34578.0,
    app_flat_1: 3229,
    char_2: 'tribbie',
    app_rate_2: '47.11%',
    avg_round_2: 38073.0,
    app_flat_2: 2447,
    char_3: 'gallagher',
    app_rate_3: '37.66%',
    avg_round_3: 34703.0,
    app_flat_3: 1889,
    char_4: 'luocha',
    app_rate_4: '29.73%',
    avg_round_4: 34383.0,
    app_flat_4: 1283,
    char_5: 'ruan-mei',
    app_rate_5: '21.16%',
    avg_round_5: 30050.0,
    app_flat_5: 633,
    char_6: 'the-herta',
    app_rate_6: '18.21%',
    avg_round_6: 40000.0,
    app_flat_6: 1155,
    char_7: 'herta',
    app_rate_7: '13.31%',
    avg_round_7: 39946.0,
    app_flat_7: 830,
    char_8: 'sunday',
    app_rate_8: '9.54%',
    avg_round_8: 31823.0,
    app_flat_8: 440,
    char_9: 'lingsha',
    app_rate_9: '8.52%',
    avg_round_9: 39363.0,
    app_flat_9: 456,
    char_10: 'huohuo',
    app_rate_10: '6.34%',
    avg_round_10: 37329.0,
    app_flat_10: 328,
    char_11: 'mydei',
    app_rate_11: '5.96%',
    avg_round_11: 29777.0,
    app_flat_11: 266,
    char_12: 'aventurine',
    app_rate_12: '4.42%',
    avg_round_12: 39868.0,
    app_flat_12: 283,
    char_13: 'jade',
    app_rate_13: '4.31%',
    avg_round_13: 40000.0,
    app_flat_13: 269,
    char_14: 'robin',
    app_rate_14: '4.31%',
    avg_round_14: 32642.0,
    app_flat_14: 168,
    char_15: 'fu-xuan',
    app_rate_15: '3.24%',
    avg_round_15: 39540.0,
    app_flat_15: 135,
    char_16: 'anaxa',
    app_rate_16: '2.03%',
    avg_round_16: 38736.0,
    app_flat_16: 97,
    char_17: 'argenti',
    app_rate_17: '1.83%',
    avg_round_17: 34944.0,
    app_flat_17: 89,
    char_18: 'sparkle',
    app_rate_18: '1.57%',
    avg_round_18: 29393.0,
    app_flat_18: 46,
    char_19: 'bronya',
    app_rate_19: '1.39%',
    avg_round_19: 31004.0,
    app_flat_19: 65,
    char_20: 'jiaoqiu',
    app_rate_20: '1.36%',
    avg_round_20: 29636.0,
    app_flat_20: 34,
    char_21: 'pela',
    app_rate_21: '1.24%',
    avg_round_21: 27884.0,
    app_flat_21: 48,
    char_22: 'serval',
    app_rate_22: '1.16%',
    avg_round_22: 37273.0,
    app_flat_22: 67,
    char_23: 'yunli',
    app_rate_23: '0.87%',
    avg_round_23: 26526,
    app_flat_23: 40,
    char_24: 'acheron',
    app_rate_24: '0.81%',
    avg_round_24: 28793.0,
    app_flat_24: 11,
    char_25: 'aglaea',
    app_rate_25: '0.52%',
    avg_round_25: 30407.0,
    app_flat_25: 6,
    char_26: 'blade',
    app_rate_26: '0.51%',
    avg_round_26: 26265.0,
    app_flat_26: 23,
    char_27: 'bailu',
    app_rate_27: '0.48%',
    avg_round_27: 32884.0,
    app_flat_27: 21,
    char_28: 'tingyun',
    app_rate_28: '0.38%',
    avg_round_28: 30939.0,
    app_flat_28: 23,
    char_29: 'lynx',
    app_rate_29: '0.32%',
    avg_round_29: 31920,
    app_flat_29: 15,
    char_30: 'clara',
    app_rate_30: '0.25%',
    avg_round_30: 26120.0,
    app_flat_30: 12
  },
  {
    char: 'tribbie',
    app: 65.4,
    char_1: 'castorice',
    app_rate_1: '54.99%',
    avg_round_1: 37576.0,
    app_flat_1: 2556,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '49.58%',
    avg_round_2: 38073.0,
    app_flat_2: 2447,
    char_3: 'the-herta',
    app_rate_3: '31.31%',
    avg_round_3: 40000.0,
    app_flat_3: 1486,
    char_4: 'gallagher',
    app_rate_4: '29.53%',
    avg_round_4: 37842.0,
    app_flat_4: 1531,
    char_5: 'luocha',
    app_rate_5: '24.76%',
    avg_round_5: 37487.0,
    app_flat_5: 1002,
    char_6: 'herta',
    app_rate_6: '20.26%',
    avg_round_6: 40000.0,
    app_flat_6: 973,
    char_7: 'lingsha',
    app_rate_7: '10.59%',
    avg_round_7: 40000.0,
    app_flat_7: 478,
    char_8: 'jade',
    app_rate_8: '10.37%',
    avg_round_8: 40000.0,
    app_flat_8: 459,
    char_9: 'huohuo',
    app_rate_9: '9.93%',
    avg_round_9: 39768.0,
    app_flat_9: 444,
    char_10: 'sunday',
    app_rate_10: '9.37%',
    avg_round_10: 34530.0,
    app_flat_10: 287,
    char_11: 'aventurine',
    app_rate_11: '8.47%',
    avg_round_11: 40000.0,
    app_flat_11: 383,
    char_12: 'fu-xuan',
    app_rate_12: '6.51%',
    avg_round_12: 40000.0,
    app_flat_12: 224,
    char_13: 'mydei',
    app_rate_13: '5.61%',
    avg_round_13: 32902.0,
    app_flat_13: 208,
    char_14: 'robin',
    app_rate_14: '3.63%',
    avg_round_14: 34825.0,
    app_flat_14: 96,
    char_15: 'ruan-mei',
    app_rate_15: '3.35%',
    avg_round_15: 33620.0,
    app_flat_15: 57,
    char_16: 'anaxa',
    app_rate_16: '2.93%',
    avg_round_16: 40000.0,
    app_flat_16: 107,
    char_17: 'acheron',
    app_rate_17: '2.57%',
    avg_round_17: 32494.0,
    app_flat_17: 35,
    char_18: 'serval',
    app_rate_18: '2.4%',
    avg_round_18: 39966.0,
    app_flat_18: 102,
    char_19: 'jiaoqiu',
    app_rate_19: '2.13%',
    avg_round_19: 34109.0,
    app_flat_19: 30,
    char_20: 'argenti',
    app_rate_20: '2.06%',
    avg_round_20: 38896.0,
    app_flat_20: 85,
    char_21: 'sparkle',
    app_rate_21: '1.34%',
    avg_round_21: 31602.0,
    app_flat_21: 18,
    char_22: 'blade',
    app_rate_22: '0.99%',
    avg_round_22: 33007.0,
    app_flat_22: 38,
    char_23: 'yunli',
    app_rate_23: '0.93%',
    avg_round_23: 30299.0,
    app_flat_23: 30,
    char_24: 'pela',
    app_rate_24: '0.9%',
    avg_round_24: 32144,
    app_flat_24: 20,
    char_25: 'jing-yuan',
    app_rate_25: '0.66%',
    avg_round_25: 33371.0,
    app_flat_25: 18,
    char_26: 'bronya',
    app_rate_26: '0.63%',
    avg_round_26: 32805,
    app_flat_26: 24,
    char_27: 'aglaea',
    app_rate_27: '0.53%',
    avg_round_27: 33193.0,
    app_flat_27: 6,
    char_28: 'tingyun-fugue',
    app_rate_28: '0.51%',
    avg_round_28: 31160,
    app_flat_28: 6,
    char_29: 'bailu',
    app_rate_29: '0.47%',
    avg_round_29: 34369.0,
    app_flat_29: 18,
    char_30: 'himeko',
    app_rate_30: '0.41%',
    avg_round_30: 31673.0,
    app_flat_30: 11
  },
  {
    char: 'the-herta',
    app: 60.26,
    char_1: 'herta',
    app_rate_1: '56.35%',
    avg_round_1: 39939.0,
    app_flat_1: 2786,
    char_2: 'tribbie',
    app_rate_2: '33.98%',
    avg_round_2: 40000.0,
    app_flat_2: 1486,
    char_3: 'jade',
    app_rate_3: '29.25%',
    avg_round_3: 40000.0,
    app_flat_3: 1370,
    char_4: 'robin',
    app_rate_4: '26.87%',
    avg_round_4: 39081.0,
    app_flat_4: 1229,
    char_5: 'aventurine',
    app_rate_5: '25.57%',
    avg_round_5: 39724.0,
    app_flat_5: 1346,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '20.81%',
    avg_round_6: 40000.0,
    app_flat_6: 1155,
    char_7: 'lingsha',
    app_rate_7: '20.03%',
    avg_round_7: 40000.0,
    app_flat_7: 989,
    char_8: 'huohuo',
    app_rate_8: '18.51%',
    avg_round_8: 39912.0,
    app_flat_8: 905,
    char_9: 'sunday',
    app_rate_9: '14.64%',
    avg_round_9: 39898.0,
    app_flat_9: 777,
    char_10: 'fu-xuan',
    app_rate_10: '13.2%',
    avg_round_10: 39758.0,
    app_flat_10: 509,
    char_11: 'ruan-mei',
    app_rate_11: '8.53%',
    avg_round_11: 38204.0,
    app_flat_11: 218,
    char_12: 'gallagher',
    app_rate_12: '7.48%',
    avg_round_12: 39982.0,
    app_flat_12: 439,
    char_13: 'anaxa',
    app_rate_13: '6.35%',
    avg_round_13: 39834.0,
    app_flat_13: 263,
    char_14: 'serval',
    app_rate_14: '5.91%',
    avg_round_14: 37983.0,
    app_flat_14: 261,
    char_15: 'argenti',
    app_rate_15: '3.26%',
    avg_round_15: 39505.0,
    app_flat_15: 153,
    char_16: 'luocha',
    app_rate_16: '3.24%',
    avg_round_16: 39710.0,
    app_flat_16: 151,
    char_17: 'sparkle',
    app_rate_17: '1.89%',
    avg_round_17: 34220.0,
    app_flat_17: 49,
    char_18: 'himeko',
    app_rate_18: '0.62%',
    avg_round_18: 33947.0,
    app_flat_18: 27,
    char_19: 'bronya',
    app_rate_19: '0.59%',
    avg_round_19: 38131.0,
    app_flat_19: 26,
    char_20: 'pela',
    app_rate_20: '0.52%',
    avg_round_20: 34538.0,
    app_flat_20: 29,
    char_21: 'castorice',
    app_rate_21: '0.43%',
    avg_round_21: 36655.0,
    app_flat_21: 14,
    char_22: 'bailu',
    app_rate_22: '0.35%',
    avg_round_22: 38870.0,
    app_flat_22: 16,
    char_23: 'lynx',
    app_rate_23: '0.25%',
    avg_round_23: 37916,
    app_flat_23: 10,
    char_24: 'jiaoqiu',
    app_rate_24: '0.19%',
    avg_round_24: 36240,
    app_flat_24: 5,
    char_25: 'gepard',
    app_rate_25: '0.13%',
    avg_round_25: 38700,
    app_flat_25: 4,
    char_26: 'rappa',
    app_rate_26: '0.12%',
    avg_round_26: 28340,
    app_flat_26: 4,
    char_27: 'tingyun-fugue',
    app_rate_27: '0.12%',
    avg_round_27: 27960,
    app_flat_27: 5,
    char_28: 'tingyun',
    app_rate_28: '0.11%',
    avg_round_28: 33547.0,
    app_flat_28: 3,
    char_29: 'march-7th',
    app_rate_29: '0.09%',
    avg_round_29: 40000,
    app_flat_29: 5,
    char_30: 'jing-yuan',
    app_rate_30: '0.08%',
    avg_round_30: 34300,
    app_flat_30: 2
  },
  {
    char: 'castorice',
    app: 58.51,
    char_1: 'trailblazer-remembrance',
    app_rate_1: '82.48%',
    avg_round_1: 34578.0,
    app_flat_1: 3229,
    char_2: 'tribbie',
    app_rate_2: '61.46%',
    avg_round_2: 37576.0,
    app_flat_2: 2556,
    char_3: 'gallagher',
    app_rate_3: '46.66%',
    avg_round_3: 34327.0,
    app_flat_3: 1891,
    char_4: 'luocha',
    app_rate_4: '39.29%',
    avg_round_4: 34147.0,
    app_flat_4: 1351,
    char_5: 'ruan-mei',
    app_rate_5: '26.84%',
    avg_round_5: 29300.0,
    app_flat_5: 647,
    char_6: 'sunday',
    app_rate_6: '11.59%',
    avg_round_6: 32082.0,
    app_flat_6: 387,
    char_7: 'lingsha',
    app_rate_7: '8.31%',
    avg_round_7: 37192.0,
    app_flat_7: 299,
    char_8: 'mydei',
    app_rate_8: '6.07%',
    avg_round_8: 31749.0,
    app_flat_8: 227,
    char_9: 'huohuo',
    app_rate_9: '3.65%',
    avg_round_9: 32800,
    app_flat_9: 116,
    char_10: 'blade',
    app_rate_10: '2.08%',
    avg_round_10: 29618.0,
    app_flat_10: 73,
    char_11: 'pela',
    app_rate_11: '1.69%',
    avg_round_11: 27338.0,
    app_flat_11: 54,
    char_12: 'sparkle',
    app_rate_12: '1.49%',
    avg_round_12: 27251.0,
    app_flat_12: 25,
    char_13: 'robin',
    app_rate_13: '1.33%',
    avg_round_13: 29331.0,
    app_flat_13: 50,
    char_14: 'fu-xuan',
    app_rate_14: '1.32%',
    avg_round_14: 34760,
    app_flat_14: 10,
    char_15: 'herta',
    app_rate_15: '1.17%',
    avg_round_15: 33081.0,
    app_flat_15: 50,
    char_16: 'bailu',
    app_rate_16: '0.62%',
    avg_round_16: 31004.0,
    app_flat_16: 18,
    char_17: 'bronya',
    app_rate_17: '0.54%',
    avg_round_17: 29769.0,
    app_flat_17: 23,
    char_18: 'jiaoqiu',
    app_rate_18: '0.51%',
    avg_round_18: 28320,
    app_flat_18: 14,
    char_19: 'jade',
    app_rate_19: '0.5%',
    avg_round_19: 33648,
    app_flat_19: 20,
    char_20: 'the-herta',
    app_rate_20: '0.44%',
    avg_round_20: 36655.0,
    app_flat_20: 14,
    char_21: 'lynx',
    app_rate_21: '0.34%',
    avg_round_21: 30732,
    app_flat_21: 10,
    char_22: 'yunli',
    app_rate_22: '0.24%',
    avg_round_22: 26255.0,
    app_flat_22: 13,
    char_23: 'tingyun-fugue',
    app_rate_23: '0.22%',
    avg_round_23: 29994.0,
    app_flat_23: 7,
    char_24: 'clara',
    app_rate_24: '0.18%',
    avg_round_24: 26156.0,
    app_flat_24: 11,
    char_25: 'jingliu',
    app_rate_25: '0.15%',
    avg_round_25: 24792,
    app_flat_25: 5,
    char_26: 'acheron',
    app_rate_26: '0.15%',
    avg_round_26: 30330,
    app_flat_26: 4,
    char_27: 'silver-wolf',
    app_rate_27: '0.11%',
    avg_round_27: 26720,
    app_flat_27: 1,
    char_28: 'aglaea',
    app_rate_28: '0.1%',
    avg_round_28: 29720,
    app_flat_28: 1,
    char_29: 'anaxa',
    app_rate_29: '0.09%',
    avg_round_29: 28928,
    app_flat_29: 5,
    char_30: 'firefly',
    app_rate_30: '0.06%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'ruan-mei',
    app: 52.31,
    char_1: 'tingyun-fugue',
    app_rate_1: '43.99%',
    avg_round_1: 28976.0,
    app_flat_1: 586,
    char_2: 'lingsha',
    app_rate_2: '35.0%',
    avg_round_2: 30898.0,
    app_flat_2: 494,
    char_3: 'castorice',
    app_rate_3: '30.02%',
    avg_round_3: 29300.0,
    app_flat_3: 647,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '27.84%',
    avg_round_4: 30050.0,
    app_flat_4: 633,
    char_5: 'gallagher',
    app_rate_5: '25.31%',
    avg_round_5: 27831.0,
    app_flat_5: 554,
    char_6: 'rappa',
    app_rate_6: '24.31%',
    avg_round_6: 29360.0,
    app_flat_6: 538,
    char_7: 'firefly',
    app_rate_7: '21.87%',
    avg_round_7: 24766.0,
    app_flat_7: 106,
    char_8: 'luocha',
    app_rate_8: '11.98%',
    avg_round_8: 28796.0,
    app_flat_8: 240,
    char_9: 'trailblazer-harmony',
    app_rate_9: '10.82%',
    avg_round_9: 26877.0,
    app_flat_9: 132,
    char_10: 'the-herta',
    app_rate_10: '9.83%',
    avg_round_10: 38204.0,
    app_flat_10: 218,
    char_11: 'herta',
    app_rate_11: '9.43%',
    avg_round_11: 34826.0,
    app_flat_11: 211,
    char_12: 'sunday',
    app_rate_12: '6.92%',
    avg_round_12: 29677.0,
    app_flat_12: 124,
    char_13: 'huohuo',
    app_rate_13: '5.11%',
    avg_round_13: 29784.0,
    app_flat_13: 102,
    char_14: 'aventurine',
    app_rate_14: '4.78%',
    avg_round_14: 29573.0,
    app_flat_14: 85,
    char_15: 'mydei',
    app_rate_15: '4.69%',
    avg_round_15: 29160,
    app_flat_15: 105,
    char_16: 'tribbie',
    app_rate_16: '4.18%',
    avg_round_16: 33620.0,
    app_flat_16: 57,
    char_17: 'himeko',
    app_rate_17: '3.6%',
    avg_round_17: 25952.0,
    app_flat_17: 46,
    char_18: 'jade',
    app_rate_18: '3.15%',
    avg_round_18: 36183.0,
    app_flat_18: 56,
    char_19: 'robin',
    app_rate_19: '2.52%',
    avg_round_19: 29519,
    app_flat_19: 40,
    char_20: 'fu-xuan',
    app_rate_20: '2.28%',
    avg_round_20: 32610.0,
    app_flat_20: 27,
    char_21: 'argenti',
    app_rate_21: '1.81%',
    avg_round_21: 30217,
    app_flat_21: 40,
    char_22: 'anaxa',
    app_rate_22: '1.74%',
    avg_round_22: 30872.0,
    app_flat_22: 32,
    char_23: 'acheron',
    app_rate_23: '1.68%',
    avg_round_23: 27370,
    app_flat_23: 8,
    char_24: 'jiaoqiu',
    app_rate_24: '1.35%',
    avg_round_24: 29190,
    app_flat_24: 4,
    char_25: 'bronya',
    app_rate_25: '1.24%',
    avg_round_25: 27480,
    app_flat_25: 23,
    char_26: 'sparkle',
    app_rate_26: '0.79%',
    avg_round_26: 25137.0,
    app_flat_26: 11,
    char_27: 'kafka',
    app_rate_27: '0.63%',
    avg_round_27: 23020,
    app_flat_27: 2,
    char_28: 'black-swan',
    app_rate_28: '0.61%',
    avg_round_28: 24160,
    app_flat_28: 1,
    char_29: 'pela',
    app_rate_29: '0.45%',
    avg_round_29: 26300.0,
    app_flat_29: 6,
    char_30: 'yunli',
    app_rate_30: '0.35%',
    avg_round_30: 24080,
    app_flat_30: 6
  },
  {
    char: 'gallagher',
    app: 42.43,
    char_1: 'castorice',
    app_rate_1: '64.35%',
    avg_round_1: 34327.0,
    app_flat_1: 1891,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '61.11%',
    avg_round_2: 34703.0,
    app_flat_2: 1889,
    char_3: 'tribbie',
    app_rate_3: '45.51%',
    avg_round_3: 37842.0,
    app_flat_3: 1531,
    char_4: 'ruan-mei',
    app_rate_4: '31.2%',
    avg_round_4: 27831.0,
    app_flat_4: 554,
    char_5: 'sunday',
    app_rate_5: '13.12%',
    avg_round_5: 32538.0,
    app_flat_5: 349,
    char_6: 'the-herta',
    app_rate_6: '10.62%',
    avg_round_6: 39982.0,
    app_flat_6: 439,
    char_7: 'tingyun-fugue',
    app_rate_7: '9.32%',
    avg_round_7: 25517.0,
    app_flat_7: 153,
    char_8: 'herta',
    app_rate_8: '8.35%',
    avg_round_8: 39800.0,
    app_flat_8: 332,
    char_9: 'rappa',
    app_rate_9: '6.84%',
    avg_round_9: 25434.0,
    app_flat_9: 150,
    char_10: 'robin',
    app_rate_10: '6.2%',
    avg_round_10: 33352.0,
    app_flat_10: 163,
    char_11: 'acheron',
    app_rate_11: '5.56%',
    avg_round_11: 27975.0,
    app_flat_11: 99,
    char_12: 'jiaoqiu',
    app_rate_12: '5.43%',
    avg_round_12: 28076.0,
    app_flat_12: 108,
    char_13: 'mydei',
    app_rate_13: '5.17%',
    avg_round_13: 30342.0,
    app_flat_13: 158,
    char_14: 'firefly',
    app_rate_14: '4.59%',
    avg_round_14: 22568.0,
    app_flat_14: 34,
    char_15: 'trailblazer-harmony',
    app_rate_15: '3.02%',
    avg_round_15: 24368.0,
    app_flat_15: 48,
    char_16: 'jade',
    app_rate_16: '2.77%',
    avg_round_16: 39366.0,
    app_flat_16: 114,
    char_17: 'pela',
    app_rate_17: '2.64%',
    avg_round_17: 27256.0,
    app_flat_17: 85,
    char_18: 'sparkle',
    app_rate_18: '2.03%',
    avg_round_18: 27674.0,
    app_flat_18: 36,
    char_19: 'bronya',
    app_rate_19: '1.63%',
    avg_round_19: 29210.0,
    app_flat_19: 39,
    char_20: 'anaxa',
    app_rate_20: '1.61%',
    avg_round_20: 34515.0,
    app_flat_20: 52,
    char_21: 'argenti',
    app_rate_21: '1.14%',
    avg_round_21: 33813.0,
    app_flat_21: 36,
    char_22: 'blade',
    app_rate_22: '1.06%',
    avg_round_22: 30863.0,
    app_flat_22: 30,
    char_23: 'serval',
    app_rate_23: '1.01%',
    avg_round_23: 38819.0,
    app_flat_23: 33,
    char_24: 'jing-yuan',
    app_rate_24: '0.66%',
    avg_round_24: 28966.0,
    app_flat_24: 11,
    char_25: 'himeko',
    app_rate_25: '0.66%',
    avg_round_25: 24211.0,
    app_flat_25: 13,
    char_26: 'black-swan',
    app_rate_26: '0.66%',
    avg_round_26: 26142.0,
    app_flat_26: 13,
    char_27: 'kafka',
    app_rate_27: '0.6%',
    avg_round_27: 27230,
    app_flat_27: 8,
    char_28: 'yunli',
    app_rate_28: '0.52%',
    avg_round_28: 24618.0,
    app_flat_28: 21,
    char_29: 'aglaea',
    app_rate_29: '0.44%',
    avg_round_29: 26864,
    app_flat_29: 5,
    char_30: 'clara',
    app_rate_30: '0.32%',
    avg_round_30: 24667.0,
    app_flat_30: 10
  },
  {
    char: 'herta',
    app: 41.43,
    char_1: 'the-herta',
    app_rate_1: '81.97%',
    avg_round_1: 39939.0,
    app_flat_1: 2786,
    char_2: 'tribbie',
    app_rate_2: '31.99%',
    avg_round_2: 40000.0,
    app_flat_2: 973,
    char_3: 'robin',
    app_rate_3: '30.61%',
    avg_round_3: 37289.0,
    app_flat_3: 861,
    char_4: 'aventurine',
    app_rate_4: '26.14%',
    avg_round_4: 39230.0,
    app_flat_4: 918,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '22.11%',
    avg_round_5: 39946.0,
    app_flat_5: 830,
    char_6: 'huohuo',
    app_rate_6: '16.24%',
    avg_round_6: 39608.0,
    app_flat_6: 537,
    char_7: 'lingsha',
    app_rate_7: '14.16%',
    avg_round_7: 40000.0,
    app_flat_7: 506,
    char_8: 'fu-xuan',
    app_rate_8: '13.95%',
    avg_round_8: 39490.0,
    app_flat_8: 352,
    char_9: 'sunday',
    app_rate_9: '13.4%',
    avg_round_9: 39837.0,
    app_flat_9: 469,
    char_10: 'ruan-mei',
    app_rate_10: '11.91%',
    avg_round_10: 34826.0,
    app_flat_10: 211,
    char_11: 'jade',
    app_rate_11: '9.21%',
    avg_round_11: 34704.0,
    app_flat_11: 241,
    char_12: 'gallagher',
    app_rate_12: '8.55%',
    avg_round_12: 39800.0,
    app_flat_12: 332,
    char_13: 'luocha',
    app_rate_13: '3.51%',
    avg_round_13: 38580.0,
    app_flat_13: 107,
    char_14: 'sparkle',
    app_rate_14: '2.8%',
    avg_round_14: 32871.0,
    app_flat_14: 41,
    char_15: 'himeko',
    app_rate_15: '2.01%',
    avg_round_15: 26428.0,
    app_flat_15: 52,
    char_16: 'castorice',
    app_rate_16: '1.65%',
    avg_round_16: 33081.0,
    app_flat_16: 50,
    char_17: 'feixiao',
    app_rate_17: '1.08%',
    avg_round_17: 28256,
    app_flat_17: 10,
    char_18: 'bronya',
    app_rate_18: '0.88%',
    avg_round_18: 33072.0,
    app_flat_18: 26,
    char_19: 'pela',
    app_rate_19: '0.86%',
    avg_round_19: 34074.0,
    app_flat_19: 28,
    char_20: 'anaxa',
    app_rate_20: '0.81%',
    avg_round_20: 34138.0,
    app_flat_20: 26,
    char_21: 'tingyun-fugue',
    app_rate_21: '0.81%',
    avg_round_21: 25029.0,
    app_flat_21: 11,
    char_22: 'argenti',
    app_rate_22: '0.64%',
    avg_round_22: 28495,
    app_flat_22: 16,
    char_23: 'yunli',
    app_rate_23: '0.62%',
    avg_round_23: 29744,
    app_flat_23: 15,
    char_24: 'bailu',
    app_rate_24: '0.46%',
    avg_round_24: 37529.0,
    app_flat_24: 15,
    char_25: 'clara',
    app_rate_25: '0.45%',
    avg_round_25: 25526.0,
    app_flat_25: 11,
    char_26: 'serval',
    app_rate_26: '0.38%',
    avg_round_26: 31926.0,
    app_flat_26: 13,
    char_27: 'tingyun',
    app_rate_27: '0.29%',
    avg_round_27: 28300,
    app_flat_27: 10,
    char_28: 'jiaoqiu',
    app_rate_28: '0.28%',
    avg_round_28: 33104,
    app_flat_28: 5,
    char_29: 'acheron',
    app_rate_29: '0.26%',
    avg_round_29: 24312,
    app_flat_29: 5,
    char_30: 'gepard',
    app_rate_30: '0.24%',
    avg_round_30: 38267.0,
    app_flat_30: 5
  },
  {
    char: 'sunday',
    app: 39.04,
    char_1: 'robin',
    app_rate_1: '25.96%',
    avg_round_1: 31121.0,
    app_flat_1: 492,
    char_2: 'the-herta',
    app_rate_2: '22.6%',
    avg_round_2: 39898.0,
    app_flat_2: 777,
    char_3: 'aventurine',
    app_rate_3: '19.99%',
    avg_round_3: 34109.0,
    app_flat_3: 450,
    char_4: 'huohuo',
    app_rate_4: '19.08%',
    avg_round_4: 33373.0,
    app_flat_4: 468,
    char_5: 'luocha',
    app_rate_5: '18.5%',
    avg_round_5: 30539.0,
    app_flat_5: 382,
    char_6: 'mydei',
    app_rate_6: '18.31%',
    avg_round_6: 29920.0,
    app_flat_6: 415,
    char_7: 'castorice',
    app_rate_7: '17.36%',
    avg_round_7: 32082.0,
    app_flat_7: 387,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '16.82%',
    avg_round_8: 31823.0,
    app_flat_8: 440,
    char_9: 'tribbie',
    app_rate_9: '15.7%',
    avg_round_9: 34530.0,
    app_flat_9: 287,
    char_10: 'gallagher',
    app_rate_10: '14.26%',
    avg_round_10: 32538.0,
    app_flat_10: 349,
    char_11: 'herta',
    app_rate_11: '14.22%',
    avg_round_11: 39837.0,
    app_flat_11: 469,
    char_12: 'lingsha',
    app_rate_12: '9.99%',
    avg_round_12: 39039.0,
    app_flat_12: 254,
    char_13: 'ruan-mei',
    app_rate_13: '9.28%',
    avg_round_13: 29677.0,
    app_flat_13: 124,
    char_14: 'argenti',
    app_rate_14: '9.0%',
    avg_round_14: 32783.0,
    app_flat_14: 246,
    char_15: 'jing-yuan',
    app_rate_15: '8.84%',
    avg_round_15: 28763.0,
    app_flat_15: 147,
    char_16: 'jiaoqiu',
    app_rate_16: '8.09%',
    avg_round_16: 28521.0,
    app_flat_16: 66,
    char_17: 'anaxa',
    app_rate_17: '7.07%',
    avg_round_17: 38041.0,
    app_flat_17: 160,
    char_18: 'jade',
    app_rate_18: '6.96%',
    avg_round_18: 39998.0,
    app_flat_18: 220,
    char_19: 'acheron',
    app_rate_19: '6.92%',
    avg_round_19: 27235.0,
    app_flat_19: 42,
    char_20: 'fu-xuan',
    app_rate_20: '5.82%',
    avg_round_20: 34886.0,
    app_flat_20: 107,
    char_21: 'aglaea',
    app_rate_21: '5.17%',
    avg_round_21: 26017.0,
    app_flat_21: 50,
    char_22: 'bronya',
    app_rate_22: '3.74%',
    avg_round_22: 30794.0,
    app_flat_22: 91,
    char_23: 'sparkle',
    app_rate_23: '3.3%',
    avg_round_23: 28855.0,
    app_flat_23: 62,
    char_24: 'yunli',
    app_rate_24: '2.63%',
    avg_round_24: 24604.0,
    app_flat_24: 63,
    char_25: 'serval',
    app_rate_25: '1.94%',
    avg_round_25: 36856.0,
    app_flat_25: 67,
    char_26: 'tingyun',
    app_rate_26: '1.94%',
    avg_round_26: 29326.0,
    app_flat_26: 54,
    char_27: 'clara',
    app_rate_27: '1.11%',
    avg_round_27: 24226.0,
    app_flat_27: 31,
    char_28: 'pela',
    app_rate_28: '1.02%',
    avg_round_28: 26831.0,
    app_flat_28: 9,
    char_29: 'tingyun-fugue',
    app_rate_29: '0.93%',
    avg_round_29: 27590,
    app_flat_29: 4,
    char_30: 'imbibitor-lunae',
    app_rate_30: '0.91%',
    avg_round_30: 21040,
    app_flat_30: 1
  },
  {
    char: 'robin',
    app: 37.63,
    char_1: 'the-herta',
    app_rate_1: '43.04%',
    avg_round_1: 39081.0,
    app_flat_1: 1229,
    char_2: 'herta',
    app_rate_2: '33.7%',
    avg_round_2: 37289.0,
    app_flat_2: 861,
    char_3: 'aventurine',
    app_rate_3: '30.1%',
    avg_round_3: 33933.0,
    app_flat_3: 691,
    char_4: 'sunday',
    app_rate_4: '26.94%',
    avg_round_4: 31121.0,
    app_flat_4: 492,
    char_5: 'jade',
    app_rate_5: '23.34%',
    avg_round_5: 38453.0,
    app_flat_5: 605,
    char_6: 'huohuo',
    app_rate_6: '20.19%',
    avg_round_6: 32858.0,
    app_flat_6: 445,
    char_7: 'lingsha',
    app_rate_7: '14.57%',
    avg_round_7: 39535.0,
    app_flat_7: 412,
    char_8: 'anaxa',
    app_rate_8: '9.0%',
    avg_round_8: 37407.0,
    app_flat_8: 206,
    char_9: 'fu-xuan',
    app_rate_9: '8.01%',
    avg_round_9: 33607.0,
    app_flat_9: 144,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '7.88%',
    avg_round_10: 32642.0,
    app_flat_10: 168,
    char_11: 'argenti',
    app_rate_11: '7.18%',
    avg_round_11: 33114.0,
    app_flat_11: 161,
    char_12: 'yunli',
    app_rate_12: '7.16%',
    avg_round_12: 24904.0,
    app_flat_12: 160,
    char_13: 'gallagher',
    app_rate_13: '6.99%',
    avg_round_13: 33352.0,
    app_flat_13: 163,
    char_14: 'tribbie',
    app_rate_14: '6.31%',
    avg_round_14: 34825.0,
    app_flat_14: 96,
    char_15: 'jing-yuan',
    app_rate_15: '6.29%',
    avg_round_15: 27987.0,
    app_flat_15: 112,
    char_16: 'acheron',
    app_rate_16: '4.98%',
    avg_round_16: 28293.0,
    app_flat_16: 37,
    char_17: 'luocha',
    app_rate_17: '4.79%',
    avg_round_17: 30043.0,
    app_flat_17: 100,
    char_18: 'aglaea',
    app_rate_18: '4.79%',
    avg_round_18: 25908.0,
    app_flat_18: 43,
    char_19: 'jiaoqiu',
    app_rate_19: '4.32%',
    avg_round_19: 29396.0,
    app_flat_19: 31,
    char_20: 'clara',
    app_rate_20: '3.64%',
    avg_round_20: 24301.0,
    app_flat_20: 83,
    char_21: 'ruan-mei',
    app_rate_21: '3.5%',
    avg_round_21: 29519,
    app_flat_21: 40,
    char_22: 'feixiao',
    app_rate_22: '3.5%',
    avg_round_22: 25666.0,
    app_flat_22: 31,
    char_23: 'sparkle',
    app_rate_23: '2.39%',
    avg_round_23: 26708.0,
    app_flat_23: 16,
    char_24: 'mydei',
    app_rate_24: '2.35%',
    avg_round_24: 28403.0,
    app_flat_24: 52,
    char_25: 'bronya',
    app_rate_25: '2.29%',
    avg_round_25: 30761,
    app_flat_25: 40,
    char_26: 'castorice',
    app_rate_26: '2.06%',
    avg_round_26: 29331.0,
    app_flat_26: 50,
    char_27: 'serval',
    app_rate_27: '1.42%',
    avg_round_27: 32101.0,
    app_flat_27: 30,
    char_28: 'tingyun',
    app_rate_28: '1.42%',
    avg_round_28: 24571.0,
    app_flat_28: 35,
    char_29: 'himeko',
    app_rate_29: '1.0%',
    avg_round_29: 24975.0,
    app_flat_29: 25,
    char_30: 'black-swan',
    app_rate_30: '0.87%',
    avg_round_30: 25360,
    app_flat_30: 2
  },
  {
    char: 'lingsha',
    app: 36.15,
    char_1: 'ruan-mei',
    app_rate_1: '50.63%',
    avg_round_1: 30898.0,
    app_flat_1: 494,
    char_2: 'tingyun-fugue',
    app_rate_2: '40.71%',
    avg_round_2: 30292.0,
    app_flat_2: 350,
    char_3: 'the-herta',
    app_rate_3: '33.38%',
    avg_round_3: 40000.0,
    app_flat_3: 989,
    char_4: 'firefly',
    app_rate_4: '20.78%',
    avg_round_4: 25644,
    app_flat_4: 70,
    char_5: 'tribbie',
    app_rate_5: '19.16%',
    avg_round_5: 40000.0,
    app_flat_5: 478,
    char_6: 'rappa',
    app_rate_6: '18.18%',
    avg_round_6: 30920.0,
    app_flat_6: 291,
    char_7: 'jade',
    app_rate_7: '16.29%',
    avg_round_7: 40000.0,
    app_flat_7: 445,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '16.23%',
    avg_round_8: 39363.0,
    app_flat_8: 456,
    char_9: 'herta',
    app_rate_9: '16.23%',
    avg_round_9: 40000.0,
    app_flat_9: 506,
    char_10: 'robin',
    app_rate_10: '15.16%',
    avg_round_10: 39535.0,
    app_flat_10: 412,
    char_11: 'castorice',
    app_rate_11: '13.45%',
    avg_round_11: 37192.0,
    app_flat_11: 299,
    char_12: 'sunday',
    app_rate_12: '10.78%',
    avg_round_12: 39039.0,
    app_flat_12: 254,
    char_13: 'trailblazer-harmony',
    app_rate_13: '6.11%',
    avg_round_13: 27367.0,
    app_flat_13: 46,
    char_14: 'lingsha',
    app_rate_14: '3.63%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'acheron',
    app_rate_15: '3.06%',
    avg_round_15: 30235.0,
    app_flat_15: 38,
    char_16: 'anaxa',
    app_rate_16: '2.94%',
    avg_round_16: 39723.0,
    app_flat_16: 78,
    char_17: 'jiaoqiu',
    app_rate_17: '2.54%',
    avg_round_17: 31091.0,
    app_flat_17: 38,
    char_18: 'serval',
    app_rate_18: '2.05%',
    avg_round_18: 39168.0,
    app_flat_18: 61,
    char_19: 'mydei',
    app_rate_19: '1.74%',
    avg_round_19: 29218.0,
    app_flat_19: 45,
    char_20: 'sparkle',
    app_rate_20: '1.62%',
    avg_round_20: 31453.0,
    app_flat_20: 15,
    char_21: 'argenti',
    app_rate_21: '1.4%',
    avg_round_21: 38379.0,
    app_flat_21: 31,
    char_22: 'himeko',
    app_rate_22: '1.22%',
    avg_round_22: 26932.0,
    app_flat_22: 20,
    char_23: 'pela',
    app_rate_23: '1.03%',
    avg_round_23: 30602.0,
    app_flat_23: 24,
    char_24: 'bronya',
    app_rate_24: '0.79%',
    avg_round_24: 29449.0,
    app_flat_24: 14,
    char_25: 'yunli',
    app_rate_25: '0.61%',
    avg_round_25: 25695,
    app_flat_25: 16,
    char_26: 'black-swan',
    app_rate_26: '0.47%',
    avg_round_26: 26585,
    app_flat_26: 8,
    char_27: 'aglaea',
    app_rate_27: '0.43%',
    avg_round_27: 26790,
    app_flat_27: 4,
    char_28: 'kafka',
    app_rate_28: '0.43%',
    avg_round_28: 24080,
    app_flat_28: 2,
    char_29: 'clara',
    app_rate_29: '0.35%',
    avg_round_29: 26063.0,
    app_flat_29: 11,
    char_30: 'blade',
    app_rate_30: '0.34%',
    avg_round_30: 24920.0,
    app_flat_30: 9
  },
  {
    char: 'aventurine',
    app: 33.24,
    char_1: 'the-herta',
    app_rate_1: '46.37%',
    avg_round_1: 39724.0,
    app_flat_1: 1346,
    char_2: 'robin',
    app_rate_2: '34.08%',
    avg_round_2: 33933.0,
    app_flat_2: 691,
    char_3: 'herta',
    app_rate_3: '32.58%',
    avg_round_3: 39230.0,
    app_flat_3: 918,
    char_4: 'acheron',
    app_rate_4: '27.64%',
    avg_round_4: 27440.0,
    app_flat_4: 331,
    char_5: 'sunday',
    app_rate_5: '23.48%',
    avg_round_5: 34109.0,
    app_flat_5: 450,
    char_6: 'jiaoqiu',
    app_rate_6: '23.42%',
    avg_round_6: 27956.0,
    app_flat_6: 273,
    char_7: 'jade',
    app_rate_7: '17.76%',
    avg_round_7: 39282.0,
    app_flat_7: 428,
    char_8: 'tribbie',
    app_rate_8: '16.66%',
    avg_round_8: 40000.0,
    app_flat_8: 383,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '9.16%',
    avg_round_9: 39868.0,
    app_flat_9: 283,
    char_10: 'sparkle',
    app_rate_10: '8.28%',
    avg_round_10: 28881.0,
    app_flat_10: 47,
    char_11: 'pela',
    app_rate_11: '7.91%',
    avg_round_11: 28255.0,
    app_flat_11: 186,
    char_12: 'ruan-mei',
    app_rate_12: '7.53%',
    avg_round_12: 29573.0,
    app_flat_12: 85,
    char_13: 'anaxa',
    app_rate_13: '6.22%',
    avg_round_13: 38052.0,
    app_flat_13: 125,
    char_14: 'argenti',
    app_rate_14: '5.68%',
    avg_round_14: 32091.0,
    app_flat_14: 126,
    char_15: 'jing-yuan',
    app_rate_15: '4.55%',
    avg_round_15: 27258.0,
    app_flat_15: 64,
    char_16: 'feixiao',
    app_rate_16: '3.09%',
    avg_round_16: 25368.0,
    app_flat_16: 26,
    char_17: 'tingyun-fugue',
    app_rate_17: '2.96%',
    avg_round_17: 25201.0,
    app_flat_17: 44,
    char_18: 'black-swan',
    app_rate_18: '2.47%',
    avg_round_18: 25649.0,
    app_flat_18: 49,
    char_19: 'kafka',
    app_rate_19: '2.36%',
    avg_round_19: 25611.0,
    app_flat_19: 42,
    char_20: 'serval',
    app_rate_20: '2.36%',
    avg_round_20: 35780,
    app_flat_20: 66,
    char_21: 'bronya',
    app_rate_21: '2.23%',
    avg_round_21: 31905.0,
    app_flat_21: 22,
    char_22: 'clara',
    app_rate_22: '1.99%',
    avg_round_22: 24189.0,
    app_flat_22: 39,
    char_23: 'yunli',
    app_rate_23: '1.97%',
    avg_round_23: 25371,
    app_flat_23: 40,
    char_24: 'rappa',
    app_rate_24: '1.72%',
    avg_round_24: 24290.0,
    app_flat_24: 30,
    char_25: 'himeko',
    app_rate_25: '1.31%',
    avg_round_25: 25411.0,
    app_flat_25: 27,
    char_26: 'tingyun',
    app_rate_26: '1.05%',
    avg_round_26: 27442.0,
    app_flat_26: 26,
    char_27: 'topaz',
    app_rate_27: '0.92%',
    avg_round_27: 23611.0,
    app_flat_27: 7,
    char_28: 'silver-wolf',
    app_rate_28: '0.79%',
    avg_round_28: 24550.0,
    app_flat_28: 16,
    char_29: 'firefly',
    app_rate_29: '0.69%',
    avg_round_29: 21520,
    app_flat_29: 3,
    char_30: 'aglaea',
    app_rate_30: '0.6%',
    avg_round_30: 23960,
    app_flat_30: 3
  },
  {
    char: 'luocha',
    app: 30.77,
    char_1: 'castorice',
    app_rate_1: '74.7%',
    avg_round_1: 34147.0,
    app_flat_1: 1351,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '66.5%',
    avg_round_2: 34383.0,
    app_flat_2: 1283,
    char_3: 'tribbie',
    app_rate_3: '52.63%',
    avg_round_3: 37487.0,
    app_flat_3: 1002,
    char_4: 'sunday',
    app_rate_4: '23.47%',
    avg_round_4: 30539.0,
    app_flat_4: 382,
    char_5: 'ruan-mei',
    app_rate_5: '20.36%',
    avg_round_5: 28796.0,
    app_flat_5: 240,
    char_6: 'mydei',
    app_rate_6: '18.32%',
    avg_round_6: 29671.0,
    app_flat_6: 302,
    char_7: 'the-herta',
    app_rate_7: '6.35%',
    avg_round_7: 39710.0,
    app_flat_7: 151,
    char_8: 'robin',
    app_rate_8: '5.86%',
    avg_round_8: 30043.0,
    app_flat_8: 100,
    char_9: 'herta',
    app_rate_9: '4.73%',
    avg_round_9: 38580.0,
    app_flat_9: 107,
    char_10: 'bronya',
    app_rate_10: '2.94%',
    avg_round_10: 28787.0,
    app_flat_10: 57,
    char_11: 'jiaoqiu',
    app_rate_11: '2.59%',
    avg_round_11: 26760,
    app_flat_11: 25,
    char_12: 'jade',
    app_rate_12: '2.59%',
    avg_round_12: 39359.0,
    app_flat_12: 56,
    char_13: 'sparkle',
    app_rate_13: '2.52%',
    avg_round_13: 27024.0,
    app_flat_13: 34,
    char_14: 'argenti',
    app_rate_14: '1.95%',
    avg_round_14: 31523.0,
    app_flat_14: 42,
    char_15: 'blade',
    app_rate_15: '1.9%',
    avg_round_15: 28922.0,
    app_flat_15: 32,
    char_16: 'anaxa',
    app_rate_16: '1.53%',
    avg_round_16: 33024.0,
    app_flat_16: 23,
    char_17: 'acheron',
    app_rate_17: '1.39%',
    avg_round_17: 25114.0,
    app_flat_17: 13,
    char_18: 'pela',
    app_rate_18: '1.23%',
    avg_round_18: 26880.0,
    app_flat_18: 18,
    char_19: 'rappa',
    app_rate_19: '0.86%',
    avg_round_19: 24086.0,
    app_flat_19: 13,
    char_20: 'yunli',
    app_rate_20: '0.76%',
    avg_round_20: 24400.0,
    app_flat_20: 14,
    char_21: 'tingyun-fugue',
    app_rate_21: '0.72%',
    avg_round_21: 25400,
    app_flat_21: 8,
    char_22: 'jing-yuan',
    app_rate_22: '0.63%',
    avg_round_22: 30098.0,
    app_flat_22: 9,
    char_23: 'clara',
    app_rate_23: '0.6%',
    avg_round_23: 24991.0,
    app_flat_23: 14,
    char_24: 'trailblazer-harmony',
    app_rate_24: '0.53%',
    avg_round_24: 23000,
    app_flat_24: 8,
    char_25: 'imbibitor-lunae',
    app_rate_25: '0.49%',
    avg_round_25: 21040,
    app_flat_25: 1,
    char_26: 'aglaea',
    app_rate_26: '0.46%',
    avg_round_26: 27460,
    app_flat_26: 2,
    char_27: 'kafka',
    app_rate_27: '0.46%',
    avg_round_27: 24133.0,
    app_flat_27: 3,
    char_28: 'black-swan',
    app_rate_28: '0.39%',
    avg_round_28: 25147.0,
    app_flat_28: 3,
    char_29: 'tingyun',
    app_rate_29: '0.37%',
    avg_round_29: 27085,
    app_flat_29: 8,
    char_30: 'serval',
    app_rate_30: '0.35%',
    avg_round_30: 35705,
    app_flat_30: 8
  },
  {
    char: 'tingyun-fugue',
    app: 24.96,
    char_1: 'ruan-mei',
    app_rate_1: '92.18%',
    avg_round_1: 28976.0,
    app_flat_1: 586,
    char_2: 'lingsha',
    app_rate_2: '58.97%',
    avg_round_2: 30292.0,
    app_flat_2: 350,
    char_3: 'rappa',
    app_rate_3: '46.86%',
    avg_round_3: 29840,
    app_flat_3: 485,
    char_4: 'firefly',
    app_rate_4: '42.63%',
    avg_round_4: 24724.0,
    app_flat_4: 102,
    char_5: 'gallagher',
    app_rate_5: '15.85%',
    avg_round_5: 25517.0,
    app_flat_5: 153,
    char_6: 'trailblazer-harmony',
    app_rate_6: '14.82%',
    avg_round_6: 33526.0,
    app_flat_6: 61,
    char_7: 'himeko',
    app_rate_7: '7.2%',
    avg_round_7: 25316.0,
    app_flat_7: 38,
    char_8: 'aventurine',
    app_rate_8: '3.94%',
    avg_round_8: 25201.0,
    app_flat_8: 44,
    char_9: 'acheron',
    app_rate_9: '3.57%',
    avg_round_9: 28497.0,
    app_flat_9: 44,
    char_10: 'huohuo',
    app_rate_10: '2.51%',
    avg_round_10: 24680.0,
    app_flat_10: 29,
    char_11: 'jiaoqiu',
    app_rate_11: '1.97%',
    avg_round_11: 29448,
    app_flat_11: 30,
    char_12: 'sunday',
    app_rate_12: '1.46%',
    avg_round_12: 27590,
    app_flat_12: 4,
    char_13: 'herta',
    app_rate_13: '1.34%',
    avg_round_13: 25029.0,
    app_flat_13: 11,
    char_14: 'tribbie',
    app_rate_14: '1.34%',
    avg_round_14: 31160,
    app_flat_14: 6,
    char_15: 'luocha',
    app_rate_15: '0.89%',
    avg_round_15: 25400,
    app_flat_15: 8,
    char_16: 'bronya',
    app_rate_16: '0.77%',
    avg_round_16: 26340,
    app_flat_16: 2,
    char_17: 'trailblazer-remembrance',
    app_rate_17: '0.69%',
    avg_round_17: 27720,
    app_flat_17: 6,
    char_18: 'fu-xuan',
    app_rate_18: '0.66%',
    avg_round_18: 24920,
    app_flat_18: 4,
    char_19: 'argenti',
    app_rate_19: '0.6%',
    avg_round_19: 26920,
    app_flat_19: 2,
    char_20: 'robin',
    app_rate_20: '0.54%',
    avg_round_20: 24467.0,
    app_flat_20: 3,
    char_21: 'boothill',
    app_rate_21: '0.51%',
    avg_round_21: 24940,
    app_flat_21: 2,
    char_22: 'castorice',
    app_rate_22: '0.51%',
    avg_round_22: 29994.0,
    app_flat_22: 7,
    char_23: 'pela',
    app_rate_23: '0.43%',
    avg_round_23: 24888,
    app_flat_23: 5,
    char_24: 'the-herta',
    app_rate_24: '0.29%',
    avg_round_24: 27960,
    app_flat_24: 5,
    char_25: 'yunli',
    app_rate_25: '0.26%',
    avg_round_25: 24800.0,
    app_flat_25: 5,
    char_26: 'jade',
    app_rate_26: '0.17%',
    avg_round_26: 34800,
    app_flat_26: 1,
    char_27: 'mydei',
    app_rate_27: '0.17%',
    avg_round_27: 24640,
    app_flat_27: 3,
    char_28: 'welt',
    app_rate_28: '0.14%',
    avg_round_28: 24000,
    app_flat_28: 1,
    char_29: 'anaxa',
    app_rate_29: '0.14%',
    avg_round_29: 30860,
    app_flat_29: 2,
    char_30: 'sparkle',
    app_rate_30: '0.11%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'huohuo',
    app: 23.14,
    char_1: 'the-herta',
    app_rate_1: '48.2%',
    avg_round_1: 39912.0,
    app_flat_1: 905,
    char_2: 'robin',
    app_rate_2: '32.83%',
    avg_round_2: 32858.0,
    app_flat_2: 445,
    char_3: 'sunday',
    app_rate_3: '32.18%',
    avg_round_3: 33373.0,
    app_flat_3: 468,
    char_4: 'herta',
    app_rate_4: '29.07%',
    avg_round_4: 39608.0,
    app_flat_4: 537,
    char_5: 'tribbie',
    app_rate_5: '28.06%',
    avg_round_5: 39768.0,
    app_flat_5: 444,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '18.85%',
    avg_round_6: 37329.0,
    app_flat_6: 328,
    char_7: 'jade',
    app_rate_7: '18.32%',
    avg_round_7: 39875.0,
    app_flat_7: 327,
    char_8: 'ruan-mei',
    app_rate_8: '11.55%',
    avg_round_8: 29784.0,
    app_flat_8: 102,
    char_9: 'castorice',
    app_rate_9: '9.24%',
    avg_round_9: 32800,
    app_flat_9: 116,
    char_10: 'argenti',
    app_rate_10: '8.53%',
    avg_round_10: 32897.0,
    app_flat_10: 146,
    char_11: 'yunli',
    app_rate_11: '6.84%',
    avg_round_11: 24813.0,
    app_flat_11: 81,
    char_12: 'anaxa',
    app_rate_12: '6.74%',
    avg_round_12: 38566.0,
    app_flat_12: 111,
    char_13: 'mydei',
    app_rate_13: '6.07%',
    avg_round_13: 28886.0,
    app_flat_13: 90,
    char_14: 'sparkle',
    app_rate_14: '5.3%',
    avg_round_14: 28945.0,
    app_flat_14: 45,
    char_15: 'jing-yuan',
    app_rate_15: '4.28%',
    avg_round_15: 30423.0,
    app_flat_15: 49,
    char_16: 'aglaea',
    app_rate_16: '4.0%',
    avg_round_16: 25497.0,
    app_flat_16: 23,
    char_17: 'serval',
    app_rate_17: '3.36%',
    avg_round_17: 37840.0,
    app_flat_17: 56,
    char_18: 'tingyun',
    app_rate_18: '2.86%',
    avg_round_18: 26616.0,
    app_flat_18: 54,
    char_19: 'tingyun-fugue',
    app_rate_19: '2.71%',
    avg_round_19: 24680.0,
    app_flat_19: 29,
    char_20: 'acheron',
    app_rate_20: '2.65%',
    avg_round_20: 25752.0,
    app_flat_20: 20,
    char_21: 'rappa',
    app_rate_21: '2.46%',
    avg_round_21: 24880.0,
    app_flat_21: 29,
    char_22: 'black-swan',
    app_rate_22: '2.34%',
    avg_round_22: 24778.0,
    app_flat_22: 9,
    char_23: 'kafka',
    app_rate_23: '2.28%',
    avg_round_23: 24380.0,
    app_flat_23: 6,
    char_24: 'jiaoqiu',
    app_rate_24: '2.25%',
    avg_round_24: 27913.0,
    app_flat_24: 18,
    char_25: 'bronya',
    app_rate_25: '2.13%',
    avg_round_25: 30408.0,
    app_flat_25: 43,
    char_26: 'clara',
    app_rate_26: '2.06%',
    avg_round_26: 24180.0,
    app_flat_26: 30,
    char_27: 'imbibitor-lunae',
    app_rate_27: '0.83%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'pela',
    app_rate_28: '0.83%',
    avg_round_28: 27609.0,
    app_flat_28: 14,
    char_29: 'himeko',
    app_rate_29: '0.59%',
    avg_round_29: 28790,
    app_flat_29: 8,
    char_30: 'firefly',
    app_rate_30: '0.46%',
    avg_round_30: 22440,
    app_flat_30: 1
  },
  {
    char: 'jade',
    app: 22.7,
    char_1: 'the-herta',
    app_rate_1: '77.65%',
    avg_round_1: 40000.0,
    app_flat_1: 1370,
    char_2: 'robin',
    app_rate_2: '38.68%',
    avg_round_2: 38453.0,
    app_flat_2: 605,
    char_3: 'tribbie',
    app_rate_3: '29.86%',
    avg_round_3: 40000.0,
    app_flat_3: 459,
    char_4: 'aventurine',
    app_rate_4: '26.0%',
    avg_round_4: 39282.0,
    app_flat_4: 428,
    char_5: 'lingsha',
    app_rate_5: '25.93%',
    avg_round_5: 40000.0,
    app_flat_5: 445,
    char_6: 'huohuo',
    app_rate_6: '18.68%',
    avg_round_6: 39875.0,
    app_flat_6: 327,
    char_7: 'herta',
    app_rate_7: '16.8%',
    avg_round_7: 34704.0,
    app_flat_7: 241,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '13.06%',
    avg_round_8: 40000.0,
    app_flat_8: 269,
    char_9: 'fu-xuan',
    app_rate_9: '12.87%',
    avg_round_9: 39285.0,
    app_flat_9: 181,
    char_10: 'sunday',
    app_rate_10: '11.96%',
    avg_round_10: 39998.0,
    app_flat_10: 220,
    char_11: 'ruan-mei',
    app_rate_11: '7.25%',
    avg_round_11: 36183.0,
    app_flat_11: 56,
    char_12: 'gallagher',
    app_rate_12: '5.18%',
    avg_round_12: 39366.0,
    app_flat_12: 114,
    char_13: 'luocha',
    app_rate_13: '3.52%',
    avg_round_13: 39359.0,
    app_flat_13: 56,
    char_14: 'anaxa',
    app_rate_14: '1.63%',
    avg_round_14: 35590.0,
    app_flat_14: 23,
    char_15: 'sparkle',
    app_rate_15: '1.54%',
    avg_round_15: 34800,
    app_flat_15: 13,
    char_16: 'castorice',
    app_rate_16: '1.29%',
    avg_round_16: 33648,
    app_flat_16: 20,
    char_17: 'feixiao',
    app_rate_17: '1.19%',
    avg_round_17: 28860,
    app_flat_17: 2,
    char_18: 'argenti',
    app_rate_18: '1.1%',
    avg_round_18: 32096.0,
    app_flat_18: 18,
    char_19: 'bronya',
    app_rate_19: '0.88%',
    avg_round_19: 39007.0,
    app_flat_19: 12,
    char_20: 'yunli',
    app_rate_20: '0.82%',
    avg_round_20: 28480.0,
    app_flat_20: 11,
    char_21: 'blade',
    app_rate_21: '0.5%',
    avg_round_21: 26152,
    app_flat_21: 5,
    char_22: 'mydei',
    app_rate_22: '0.44%',
    avg_round_22: 27413.0,
    app_flat_22: 6,
    char_23: 'clara',
    app_rate_23: '0.44%',
    avg_round_23: 24930.0,
    app_flat_23: 6,
    char_24: 'lynx',
    app_rate_24: '0.38%',
    avg_round_24: 38326.0,
    app_flat_24: 7,
    char_25: 'bailu',
    app_rate_25: '0.38%',
    avg_round_25: 37576,
    app_flat_25: 5,
    char_26: 'jiaoqiu',
    app_rate_26: '0.35%',
    avg_round_26: 36440,
    app_flat_26: 3,
    char_27: 'pela',
    app_rate_27: '0.22%',
    avg_round_27: 32260,
    app_flat_27: 2,
    char_28: 'tingyun',
    app_rate_28: '0.22%',
    avg_round_28: 40000,
    app_flat_28: 1,
    char_29: 'tingyun-fugue',
    app_rate_29: '0.19%',
    avg_round_29: 34800,
    app_flat_29: 1,
    char_30: 'jing-yuan',
    app_rate_30: '0.16%',
    avg_round_30: 22040,
    app_flat_30: 1
  },
  {
    char: 'acheron',
    app: 18.89,
    char_1: 'jiaoqiu',
    app_rate_1: '78.23%',
    avg_round_1: 28077.0,
    app_flat_1: 511,
    char_2: 'aventurine',
    app_rate_2: '48.64%',
    avg_round_2: 27440.0,
    app_flat_2: 331,
    char_3: 'pela',
    app_rate_3: '25.81%',
    avg_round_3: 27935.0,
    app_flat_3: 315,
    char_4: 'sparkle',
    app_rate_4: '23.13%',
    avg_round_4: 26219.0,
    app_flat_4: 28,
    char_5: 'fu-xuan',
    app_rate_5: '19.58%',
    avg_round_5: 27025.0,
    app_flat_5: 95,
    char_6: 'sunday',
    app_rate_6: '14.3%',
    avg_round_6: 27235.0,
    app_flat_6: 42,
    char_7: 'gallagher',
    app_rate_7: '12.49%',
    avg_round_7: 27975.0,
    app_flat_7: 99,
    char_8: 'black-swan',
    app_rate_8: '10.04%',
    avg_round_8: 25558.0,
    app_flat_8: 108,
    char_9: 'robin',
    app_rate_9: '9.92%',
    avg_round_9: 28293.0,
    app_flat_9: 37,
    char_10: 'kafka',
    app_rate_10: '9.47%',
    avg_round_10: 25382.0,
    app_flat_10: 82,
    char_11: 'tribbie',
    app_rate_11: '8.91%',
    avg_round_11: 32494.0,
    app_flat_11: 35,
    char_12: 'lingsha',
    app_rate_12: '5.85%',
    avg_round_12: 30235.0,
    app_flat_12: 38,
    char_13: 'bronya',
    app_rate_13: '5.55%',
    avg_round_13: 27872,
    app_flat_13: 5,
    char_14: 'tingyun-fugue',
    app_rate_14: '4.72%',
    avg_round_14: 28497.0,
    app_flat_14: 44,
    char_15: 'ruan-mei',
    app_rate_15: '4.64%',
    avg_round_15: 27370,
    app_flat_15: 8,
    char_16: 'huohuo',
    app_rate_16: '3.25%',
    avg_round_16: 25752.0,
    app_flat_16: 20,
    char_17: 'trailblazer-remembrance',
    app_rate_17: '2.94%',
    avg_round_17: 28793.0,
    app_flat_17: 11,
    char_18: 'silver-wolf',
    app_rate_18: '2.94%',
    avg_round_18: 24634.0,
    app_flat_18: 25,
    char_19: 'luocha',
    app_rate_19: '2.26%',
    avg_round_19: 25114.0,
    app_flat_19: 13,
    char_20: 'gepard',
    app_rate_20: '1.89%',
    avg_round_20: 25837.0,
    app_flat_20: 14,
    char_21: 'welt',
    app_rate_21: '0.6%',
    avg_round_21: 23520,
    app_flat_21: 4,
    char_22: 'herta',
    app_rate_22: '0.57%',
    avg_round_22: 24312,
    app_flat_22: 5,
    char_23: 'himeko',
    app_rate_23: '0.49%',
    avg_round_23: 23720.0,
    app_flat_23: 4,
    char_24: 'castorice',
    app_rate_24: '0.45%',
    avg_round_24: 30330,
    app_flat_24: 4,
    char_25: 'yunli',
    app_rate_25: '0.42%',
    avg_round_25: 28413.0,
    app_flat_25: 3,
    char_26: 'march-7th',
    app_rate_26: '0.38%',
    avg_round_26: 27053.0,
    app_flat_26: 3,
    char_27: 'anaxa',
    app_rate_27: '0.34%',
    avg_round_27: 29600,
    app_flat_27: 3,
    char_28: 'firefly',
    app_rate_28: '0.3%',
    avg_round_28: 24960,
    app_flat_28: 1,
    char_29: 'bailu',
    app_rate_29: '0.3%',
    avg_round_29: 24120,
    app_flat_29: 2,
    char_30: 'clara',
    app_rate_30: '0.23%',
    avg_round_30: 22260,
    app_flat_30: 2
  },
  {
    char: 'jiaoqiu',
    app: 16.56,
    char_1: 'acheron',
    app_rate_1: '89.24%',
    avg_round_1: 28077.0,
    app_flat_1: 511,
    char_2: 'aventurine',
    app_rate_2: '47.01%',
    avg_round_2: 27956.0,
    app_flat_2: 273,
    char_3: 'sparkle',
    app_rate_3: '22.69%',
    avg_round_3: 26852.0,
    app_flat_3: 27,
    char_4: 'sunday',
    app_rate_4: '19.07%',
    avg_round_4: 28521.0,
    app_flat_4: 66,
    char_5: 'pela',
    app_rate_5: '18.94%',
    avg_round_5: 28415.0,
    app_flat_5: 277,
    char_6: 'fu-xuan',
    app_rate_6: '16.92%',
    avg_round_6: 27884.0,
    app_flat_6: 71,
    char_7: 'gallagher',
    app_rate_7: '13.9%',
    avg_round_7: 28076.0,
    app_flat_7: 108,
    char_8: 'robin',
    app_rate_8: '9.81%',
    avg_round_8: 29396.0,
    app_flat_8: 31,
    char_9: 'tribbie',
    app_rate_9: '8.39%',
    avg_round_9: 34109.0,
    app_flat_9: 30,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '5.64%',
    avg_round_10: 29636.0,
    app_flat_10: 34,
    char_11: 'mydei',
    app_rate_11: '5.55%',
    avg_round_11: 30620,
    app_flat_11: 34,
    char_12: 'lingsha',
    app_rate_12: '5.55%',
    avg_round_12: 31091.0,
    app_flat_12: 38,
    char_13: 'bronya',
    app_rate_13: '5.29%',
    avg_round_13: 28737.0,
    app_flat_13: 7,
    char_14: 'luocha',
    app_rate_14: '4.82%',
    avg_round_14: 26760,
    app_flat_14: 25,
    char_15: 'ruan-mei',
    app_rate_15: '4.26%',
    avg_round_15: 29190,
    app_flat_15: 4,
    char_16: 'huohuo',
    app_rate_16: '3.14%',
    avg_round_16: 27913.0,
    app_flat_16: 18,
    char_17: 'tingyun-fugue',
    app_rate_17: '2.97%',
    avg_round_17: 29448,
    app_flat_17: 30,
    char_18: 'black-swan',
    app_rate_18: '2.76%',
    avg_round_18: 26687.0,
    app_flat_18: 39,
    char_19: 'kafka',
    app_rate_19: '2.54%',
    avg_round_19: 28929.0,
    app_flat_19: 17,
    char_20: 'castorice',
    app_rate_20: '1.81%',
    avg_round_20: 28320,
    app_flat_20: 14,
    char_21: 'silver-wolf',
    app_rate_21: '1.42%',
    avg_round_21: 25578.0,
    app_flat_21: 15,
    char_22: 'argenti',
    app_rate_22: '1.16%',
    avg_round_22: 26608,
    app_flat_22: 5,
    char_23: 'gepard',
    app_rate_23: '1.03%',
    avg_round_23: 27640,
    app_flat_23: 6,
    char_24: 'anaxa',
    app_rate_24: '0.99%',
    avg_round_24: 29310,
    app_flat_24: 4,
    char_25: 'the-herta',
    app_rate_25: '0.69%',
    avg_round_25: 36240,
    app_flat_25: 5,
    char_26: 'herta',
    app_rate_26: '0.69%',
    avg_round_26: 33104,
    app_flat_26: 5,
    char_27: 'welt',
    app_rate_27: '0.52%',
    avg_round_27: 25360,
    app_flat_27: 2,
    char_28: 'jade',
    app_rate_28: '0.47%',
    avg_round_28: 36440,
    app_flat_28: 3,
    char_29: 'jing-yuan',
    app_rate_29: '0.43%',
    avg_round_29: 26600,
    app_flat_29: 1,
    char_30: 'yunli',
    app_rate_30: '0.3%',
    avg_round_30: 25660,
    app_flat_30: 2
  },
  {
    char: 'fu-xuan',
    app: 15.03,
    char_1: 'the-herta',
    app_rate_1: '52.92%',
    avg_round_1: 39758.0,
    app_flat_1: 509,
    char_2: 'herta',
    app_rate_2: '38.45%',
    avg_round_2: 39490.0,
    app_flat_2: 352,
    char_3: 'tribbie',
    app_rate_3: '28.31%',
    avg_round_3: 40000.0,
    app_flat_3: 224,
    char_4: 'acheron',
    app_rate_4: '24.61%',
    avg_round_4: 27025.0,
    app_flat_4: 95,
    char_5: 'robin',
    app_rate_5: '20.06%',
    avg_round_5: 33607.0,
    app_flat_5: 144,
    char_6: 'jade',
    app_rate_6: '19.44%',
    avg_round_6: 39285.0,
    app_flat_6: 181,
    char_7: 'jiaoqiu',
    app_rate_7: '18.63%',
    avg_round_7: 27884.0,
    app_flat_7: 71,
    char_8: 'sunday',
    app_rate_8: '15.13%',
    avg_round_8: 34886.0,
    app_flat_8: 107,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '14.84%',
    avg_round_9: 39540.0,
    app_flat_9: 135,
    char_10: 'sparkle',
    app_rate_10: '14.65%',
    avg_round_10: 28960,
    app_flat_10: 19,
    char_11: 'ruan-mei',
    app_rate_11: '7.92%',
    avg_round_11: 32610.0,
    app_flat_11: 27,
    char_12: 'pela',
    app_rate_12: '7.49%',
    avg_round_12: 28005.0,
    app_flat_12: 53,
    char_13: 'castorice',
    app_rate_13: '5.12%',
    avg_round_13: 34760,
    app_flat_13: 10,
    char_14: 'anaxa',
    app_rate_14: '3.89%',
    avg_round_14: 37842.0,
    app_flat_14: 30,
    char_15: 'serval',
    app_rate_15: '2.8%',
    avg_round_15: 35270,
    app_flat_15: 24,
    char_16: 'bronya',
    app_rate_16: '2.61%',
    avg_round_16: 31853.0,
    app_flat_16: 12,
    char_17: 'black-swan',
    app_rate_17: '2.47%',
    avg_round_17: 25195.0,
    app_flat_17: 22,
    char_18: 'argenti',
    app_rate_18: '2.37%',
    avg_round_18: 33727.0,
    app_flat_18: 22,
    char_19: 'jing-yuan',
    app_rate_19: '2.23%',
    avg_round_19: 29373.0,
    app_flat_19: 12,
    char_20: 'kafka',
    app_rate_20: '2.09%',
    avg_round_20: 25495.0,
    app_flat_20: 16,
    char_21: 'yunli',
    app_rate_21: '1.99%',
    avg_round_21: 24500,
    app_flat_21: 12,
    char_22: 'aglaea',
    app_rate_22: '1.75%',
    avg_round_22: 24493.0,
    app_flat_22: 6,
    char_23: 'silver-wolf',
    app_rate_23: '1.23%',
    avg_round_23: 24370,
    app_flat_23: 4,
    char_24: 'tingyun-fugue',
    app_rate_24: '1.09%',
    avg_round_24: 24920,
    app_flat_24: 4,
    char_25: 'himeko',
    app_rate_25: '0.95%',
    avg_round_25: 29206.0,
    app_flat_25: 7,
    char_26: 'tingyun',
    app_rate_26: '0.85%',
    avg_round_26: 25547.0,
    app_flat_26: 5,
    char_27: 'clara',
    app_rate_27: '0.62%',
    avg_round_27: 23152,
    app_flat_27: 5,
    char_28: 'gallagher',
    app_rate_28: '0.62%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'qingque',
    app_rate_29: '0.52%',
    avg_round_29: 24080,
    app_flat_29: 1,
    char_30: 'feixiao',
    app_rate_30: '0.52%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'rappa',
    app: 13.26,
    char_1: 'ruan-mei',
    app_rate_1: '95.91%',
    avg_round_1: 29360.0,
    app_flat_1: 538,
    char_2: 'tingyun-fugue',
    app_rate_2: '88.23%',
    avg_round_2: 29840,
    app_flat_2: 485,
    char_3: 'lingsha',
    app_rate_3: '49.57%',
    avg_round_3: 30920.0,
    app_flat_3: 291,
    char_4: 'trailblazer-harmony',
    app_rate_4: '23.82%',
    avg_round_4: 29148.0,
    app_flat_4: 138,
    char_5: 'gallagher',
    app_rate_5: '21.88%',
    avg_round_5: 25434.0,
    app_flat_5: 150,
    char_6: 'aventurine',
    app_rate_6: '4.3%',
    avg_round_6: 24290.0,
    app_flat_6: 30,
    char_7: 'huohuo',
    app_rate_7: '4.3%',
    avg_round_7: 24880.0,
    app_flat_7: 29,
    char_8: 'firefly',
    app_rate_8: '2.37%',
    avg_round_8: 25267.0,
    app_flat_8: 3,
    char_9: 'luocha',
    app_rate_9: '1.99%',
    avg_round_9: 24086.0,
    app_flat_9: 13,
    char_10: 'himeko',
    app_rate_10: '1.45%',
    avg_round_10: 29768,
    app_flat_10: 5,
    char_11: 'sunday',
    app_rate_11: '1.13%',
    avg_round_11: 25453.0,
    app_flat_11: 6,
    char_12: 'tribbie',
    app_rate_12: '0.65%',
    avg_round_12: 31350,
    app_flat_12: 4,
    char_13: 'trailblazer-remembrance',
    app_rate_13: '0.54%',
    avg_round_13: 28333.0,
    app_flat_13: 3,
    char_14: 'the-herta',
    app_rate_14: '0.54%',
    avg_round_14: 28340,
    app_flat_14: 4,
    char_15: 'fu-xuan',
    app_rate_15: '0.48%',
    avg_round_15: 27240,
    app_flat_15: 2,
    char_16: 'robin',
    app_rate_16: '0.43%',
    avg_round_16: 22970,
    app_flat_16: 4,
    char_17: 'yunli',
    app_rate_17: '0.27%',
    avg_round_17: 22227.0,
    app_flat_17: 3,
    char_18: 'herta',
    app_rate_18: '0.27%',
    avg_round_18: 25440,
    app_flat_18: 1,
    char_19: 'anaxa',
    app_rate_19: '0.22%',
    avg_round_19: 29627.0,
    app_flat_19: 3,
    char_20: 'argenti',
    app_rate_20: '0.16%',
    avg_round_20: 21560,
    app_flat_20: 1,
    char_21: 'acheron',
    app_rate_21: '0.16%',
    avg_round_21: 33580,
    app_flat_21: 2,
    char_22: 'bronya',
    app_rate_22: '0.16%',
    avg_round_22: 24920,
    app_flat_22: 2,
    char_23: 'boothill',
    app_rate_23: '0.16%',
    avg_round_23: 24000,
    app_flat_23: 1,
    char_24: 'pela',
    app_rate_24: '0.16%',
    avg_round_24: 25220,
    app_flat_24: 2,
    char_25: 'mydei',
    app_rate_25: '0.11%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'sparkle',
    app_rate_26: '0.11%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'jiaoqiu',
    app_rate_27: '0.11%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'lynx',
    app_rate_28: '0.11%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'welt',
    app_rate_29: '0.11%',
    avg_round_29: 24000,
    app_flat_29: 1,
    char_30: 'silver-wolf',
    app_rate_30: '0.05%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'firefly',
    app: 12.15,
    char_1: 'ruan-mei',
    app_rate_1: '94.19%',
    avg_round_1: 24766.0,
    app_flat_1: 106,
    char_2: 'tingyun-fugue',
    app_rate_2: '87.62%',
    avg_round_2: 24724.0,
    app_flat_2: 102,
    char_3: 'lingsha',
    app_rate_3: '61.85%',
    avg_round_3: 25644,
    app_flat_3: 70,
    char_4: 'trailblazer-harmony',
    app_rate_4: '22.59%',
    avg_round_4: 24593.0,
    app_flat_4: 12,
    char_5: 'gallagher',
    app_rate_5: '16.02%',
    avg_round_5: 22568.0,
    app_flat_5: 34,
    char_6: 'himeko',
    app_rate_6: '6.22%',
    avg_round_6: 24728,
    app_flat_6: 10,
    char_7: 'rappa',
    app_rate_7: '2.58%',
    avg_round_7: 25267.0,
    app_flat_7: 3,
    char_8: 'aventurine',
    app_rate_8: '1.88%',
    avg_round_8: 21520,
    app_flat_8: 3,
    char_9: 'bronya',
    app_rate_9: '1.06%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'huohuo',
    app_rate_10: '0.88%',
    avg_round_10: 22440,
    app_flat_10: 1,
    char_11: 'luocha',
    app_rate_11: '0.7%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'fu-xuan',
    app_rate_12: '0.53%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'acheron',
    app_rate_13: '0.47%',
    avg_round_13: 24960,
    app_flat_13: 1,
    char_14: 'herta',
    app_rate_14: '0.41%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'tribbie',
    app_rate_15: '0.41%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'sunday',
    app_rate_16: '0.35%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'robin',
    app_rate_17: '0.29%',
    avg_round_17: 21200,
    app_flat_17: 1,
    char_18: 'castorice',
    app_rate_18: '0.29%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'trailblazer-remembrance',
    app_rate_19: '0.29%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'jiaoqiu',
    app_rate_20: '0.23%',
    avg_round_20: 24960,
    app_flat_20: 1,
    char_21: 'mydei',
    app_rate_21: '0.18%',
    avg_round_21: 21200,
    app_flat_21: 1,
    char_22: 'pela',
    app_rate_22: '0.12%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'yunli',
    app_rate_23: '0.12%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'clara',
    app_rate_24: '0.12%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'feixiao',
    app_rate_25: '0.06%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'anaxa',
    app_rate_26: '0.06%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'asta',
    app_rate_27: '0.06%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'tingyun',
    app_rate_28: '0.06%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'sparkle',
    app_rate_29: '0.06%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'argenti',
    app_rate_30: '0.06%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'mydei',
    app: 12.15,
    char_1: 'sunday',
    app_rate_1: '58.86%',
    avg_round_1: 29920.0,
    app_flat_1: 415,
    char_2: 'luocha',
    app_rate_2: '46.42%',
    avg_round_2: 29671.0,
    app_flat_2: 302,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '33.8%',
    avg_round_3: 29777.0,
    app_flat_3: 266,
    char_4: 'tribbie',
    app_rate_4: '30.22%',
    avg_round_4: 32902.0,
    app_flat_4: 208,
    char_5: 'castorice',
    app_rate_5: '29.23%',
    avg_round_5: 31749.0,
    app_flat_5: 227,
    char_6: 'ruan-mei',
    app_rate_6: '20.19%',
    avg_round_6: 29160,
    app_flat_6: 105,
    char_7: 'gallagher',
    app_rate_7: '18.08%',
    avg_round_7: 30342.0,
    app_flat_7: 158,
    char_8: 'bronya',
    app_rate_8: '12.5%',
    avg_round_8: 29373.0,
    app_flat_8: 108,
    char_9: 'huohuo',
    app_rate_9: '11.56%',
    avg_round_9: 28886.0,
    app_flat_9: 90,
    char_10: 'sparkle',
    app_rate_10: '8.8%',
    avg_round_10: 28660,
    app_flat_10: 68,
    char_11: 'jiaoqiu',
    app_rate_11: '7.57%',
    avg_round_11: 30620,
    app_flat_11: 34,
    char_12: 'robin',
    app_rate_12: '7.28%',
    avg_round_12: 28403.0,
    app_flat_12: 52,
    char_13: 'lingsha',
    app_rate_13: '5.16%',
    avg_round_13: 29218.0,
    app_flat_13: 45,
    char_14: 'lynx',
    app_rate_14: '1.53%',
    avg_round_14: 26369.0,
    app_flat_14: 15,
    char_15: 'blade',
    app_rate_15: '0.88%',
    avg_round_15: 27600,
    app_flat_15: 4,
    char_16: 'argenti',
    app_rate_16: '0.88%',
    avg_round_16: 26424,
    app_flat_16: 5,
    char_17: 'jade',
    app_rate_17: '0.82%',
    avg_round_17: 27413.0,
    app_flat_17: 6,
    char_18: 'yunli',
    app_rate_18: '0.82%',
    avg_round_18: 24300.0,
    app_flat_18: 8,
    char_19: 'clara',
    app_rate_19: '0.65%',
    avg_round_19: 25022.0,
    app_flat_19: 9,
    char_20: 'pela',
    app_rate_20: '0.53%',
    avg_round_20: 27570,
    app_flat_20: 4,
    char_21: 'herta',
    app_rate_21: '0.47%',
    avg_round_21: 28040,
    app_flat_21: 4,
    char_22: 'bailu',
    app_rate_22: '0.41%',
    avg_round_22: 27140,
    app_flat_22: 2,
    char_23: 'aventurine',
    app_rate_23: '0.41%',
    avg_round_23: 25320,
    app_flat_23: 2,
    char_24: 'anaxa',
    app_rate_24: '0.35%',
    avg_round_24: 28360.0,
    app_flat_24: 4,
    char_25: 'tingyun-fugue',
    app_rate_25: '0.35%',
    avg_round_25: 24640,
    app_flat_25: 3,
    char_26: 'fu-xuan',
    app_rate_26: '0.29%',
    avg_round_26: 27840,
    app_flat_26: 2,
    char_27: 'march-7th-swordmaster',
    app_rate_27: '0.29%',
    avg_round_27: 24192,
    app_flat_27: 5,
    char_28: 'acheron',
    app_rate_28: '0.18%',
    avg_round_28: 32600,
    app_flat_28: 1,
    char_29: 'firefly',
    app_rate_29: '0.18%',
    avg_round_29: 21200,
    app_flat_29: 1,
    char_30: 'rappa',
    app_rate_30: '0.12%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'sparkle',
    app: 9.76,
    char_1: 'acheron',
    app_rate_1: '44.78%',
    avg_round_1: 26219.0,
    app_flat_1: 28,
    char_2: 'jiaoqiu',
    app_rate_2: '38.5%',
    avg_round_2: 26852.0,
    app_flat_2: 27,
    char_3: 'aventurine',
    app_rate_3: '28.2%',
    avg_round_3: 28881.0,
    app_flat_3: 47,
    char_4: 'fu-xuan',
    app_rate_4: '22.57%',
    avg_round_4: 28960,
    app_flat_4: 19,
    char_5: 'sunday',
    app_rate_5: '13.22%',
    avg_round_5: 28855.0,
    app_flat_5: 62,
    char_6: 'huohuo',
    app_rate_6: '12.56%',
    avg_round_6: 28945.0,
    app_flat_6: 45,
    char_7: 'herta',
    app_rate_7: '11.91%',
    avg_round_7: 32871.0,
    app_flat_7: 41,
    char_8: 'the-herta',
    app_rate_8: '11.69%',
    avg_round_8: 34220.0,
    app_flat_8: 49,
    char_9: 'trailblazer-remembrance',
    app_rate_9: '11.1%',
    avg_round_9: 29393.0,
    app_flat_9: 46,
    char_10: 'mydei',
    app_rate_10: '10.96%',
    avg_round_10: 28660,
    app_flat_10: 68,
    char_11: 'robin',
    app_rate_11: '9.2%',
    avg_round_11: 26708.0,
    app_flat_11: 16,
    char_12: 'tribbie',
    app_rate_12: '8.98%',
    avg_round_12: 31602.0,
    app_flat_12: 18,
    char_13: 'castorice',
    app_rate_13: '8.91%',
    avg_round_13: 27251.0,
    app_flat_13: 25,
    char_14: 'gallagher',
    app_rate_14: '8.84%',
    avg_round_14: 27674.0,
    app_flat_14: 36,
    char_15: 'luocha',
    app_rate_15: '7.96%',
    avg_round_15: 27024.0,
    app_flat_15: 34,
    char_16: 'lingsha',
    app_rate_16: '5.99%',
    avg_round_16: 31453.0,
    app_flat_16: 15,
    char_17: 'pela',
    app_rate_17: '5.41%',
    avg_round_17: 23240,
    app_flat_17: 3,
    char_18: 'yunli',
    app_rate_18: '5.41%',
    avg_round_18: 24530,
    app_flat_18: 8,
    char_19: 'argenti',
    app_rate_19: '4.53%',
    avg_round_19: 27271.0,
    app_flat_19: 25,
    char_20: 'ruan-mei',
    app_rate_20: '4.24%',
    avg_round_20: 25137.0,
    app_flat_20: 11,
    char_21: 'jade',
    app_rate_21: '3.58%',
    avg_round_21: 34800,
    app_flat_21: 13,
    char_22: 'imbibitor-lunae',
    app_rate_22: '3.14%',
    avg_round_22: 21040,
    app_flat_22: 1,
    char_23: 'clara',
    app_rate_23: '2.92%',
    avg_round_23: 24109.0,
    app_flat_23: 15,
    char_24: 'tingyun',
    app_rate_24: '2.05%',
    avg_round_24: 24620.0,
    app_flat_24: 8,
    char_25: 'bronya',
    app_rate_25: '1.97%',
    avg_round_25: 27680,
    app_flat_25: 14,
    char_26: 'anaxa',
    app_rate_26: '1.75%',
    avg_round_26: 29251.0,
    app_flat_26: 7,
    char_27: 'silver-wolf',
    app_rate_27: '1.39%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'qingque',
    app_rate_28: '1.17%',
    avg_round_28: 24360.0,
    app_flat_28: 4,
    char_29: 'jing-yuan',
    app_rate_29: '1.17%',
    avg_round_29: 24360,
    app_flat_29: 1,
    char_30: 'gepard',
    app_rate_30: '0.95%',
    avg_round_30: 24240,
    app_flat_30: 1
  },
  {
    char: 'anaxa',
    app: 7.77,
    char_1: 'the-herta',
    app_rate_1: '49.27%',
    avg_round_1: 39834.0,
    app_flat_1: 263,
    char_2: 'robin',
    app_rate_2: '43.58%',
    avg_round_2: 37407.0,
    app_flat_2: 206,
    char_3: 'sunday',
    app_rate_3: '35.5%',
    avg_round_3: 38041.0,
    app_flat_3: 160,
    char_4: 'aventurine',
    app_rate_4: '26.61%',
    avg_round_4: 38052.0,
    app_flat_4: 125,
    char_5: 'tribbie',
    app_rate_5: '24.68%',
    avg_round_5: 40000.0,
    app_flat_5: 107,
    char_6: 'huohuo',
    app_rate_6: '20.09%',
    avg_round_6: 38566.0,
    app_flat_6: 111,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '17.98%',
    avg_round_7: 38736.0,
    app_flat_7: 97,
    char_8: 'lingsha',
    app_rate_8: '13.67%',
    avg_round_8: 39723.0,
    app_flat_8: 78,
    char_9: 'ruan-mei',
    app_rate_9: '11.74%',
    avg_round_9: 30872.0,
    app_flat_9: 32,
    char_10: 'bronya',
    app_rate_10: '9.08%',
    avg_round_10: 33281.0,
    app_flat_10: 44,
    char_11: 'gallagher',
    app_rate_11: '8.81%',
    avg_round_11: 34515.0,
    app_flat_11: 52,
    char_12: 'fu-xuan',
    app_rate_12: '7.52%',
    avg_round_12: 37842.0,
    app_flat_12: 30,
    char_13: 'luocha',
    app_rate_13: '6.06%',
    avg_round_13: 33024.0,
    app_flat_13: 23,
    char_14: 'jade',
    app_rate_14: '4.77%',
    avg_round_14: 35590.0,
    app_flat_14: 23,
    char_15: 'herta',
    app_rate_15: '4.31%',
    avg_round_15: 34138.0,
    app_flat_15: 26,
    char_16: 'argenti',
    app_rate_16: '2.48%',
    avg_round_16: 28247.0,
    app_flat_16: 10,
    char_17: 'sparkle',
    app_rate_17: '2.2%',
    avg_round_17: 29251.0,
    app_flat_17: 7,
    char_18: 'jiaoqiu',
    app_rate_18: '2.11%',
    avg_round_18: 29310,
    app_flat_18: 4,
    char_19: 'tingyun',
    app_rate_19: '1.56%',
    avg_round_19: 33674.0,
    app_flat_19: 7,
    char_20: 'himeko',
    app_rate_20: '1.1%',
    avg_round_20: 28352,
    app_flat_20: 5,
    char_21: 'acheron',
    app_rate_21: '0.83%',
    avg_round_21: 29600,
    app_flat_21: 3,
    char_22: 'asta',
    app_rate_22: '0.73%',
    avg_round_22: 37648,
    app_flat_22: 5,
    char_23: 'jing-yuan',
    app_rate_23: '0.73%',
    avg_round_23: 26940,
    app_flat_23: 2,
    char_24: 'castorice',
    app_rate_24: '0.64%',
    avg_round_24: 28928,
    app_flat_24: 5,
    char_25: 'mydei',
    app_rate_25: '0.55%',
    avg_round_25: 28360.0,
    app_flat_25: 4,
    char_26: 'pela',
    app_rate_26: '0.55%',
    avg_round_26: 31060,
    app_flat_26: 2,
    char_27: 'tingyun-fugue',
    app_rate_27: '0.46%',
    avg_round_27: 30860,
    app_flat_27: 2,
    char_28: 'rappa',
    app_rate_28: '0.37%',
    avg_round_28: 29627.0,
    app_flat_28: 3,
    char_29: 'trailblazer-harmony',
    app_rate_29: '0.28%',
    avg_round_29: 21760,
    app_flat_29: 1,
    char_30: 'bailu',
    app_rate_30: '0.28%',
    avg_round_30: 30980,
    app_flat_30: 2
  },
  {
    char: 'argenti',
    app: 6.94,
    char_1: 'sunday',
    app_rate_1: '50.67%',
    avg_round_1: 32783.0,
    app_flat_1: 246,
    char_2: 'robin',
    app_rate_2: '38.95%',
    avg_round_2: 33114.0,
    app_flat_2: 161,
    char_3: 'huohuo',
    app_rate_3: '28.47%',
    avg_round_3: 32897.0,
    app_flat_3: 146,
    char_4: 'the-herta',
    app_rate_4: '28.37%',
    avg_round_4: 39505.0,
    app_flat_4: 153,
    char_5: 'aventurine',
    app_rate_5: '27.24%',
    avg_round_5: 32091.0,
    app_flat_5: 126,
    char_6: 'tribbie',
    app_rate_6: '19.42%',
    avg_round_6: 38896.0,
    app_flat_6: 85,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '18.19%',
    avg_round_7: 34944.0,
    app_flat_7: 89,
    char_8: 'ruan-mei',
    app_rate_8: '13.67%',
    avg_round_8: 30217,
    app_flat_8: 40,
    char_9: 'tingyun',
    app_rate_9: '12.23%',
    avg_round_9: 28155.0,
    app_flat_9: 77,
    char_10: 'luocha',
    app_rate_10: '8.63%',
    avg_round_10: 31523.0,
    app_flat_10: 42,
    char_11: 'lingsha',
    app_rate_11: '7.3%',
    avg_round_11: 38379.0,
    app_flat_11: 31,
    char_12: 'gallagher',
    app_rate_12: '6.99%',
    avg_round_12: 33813.0,
    app_flat_12: 36,
    char_13: 'bronya',
    app_rate_13: '6.78%',
    avg_round_13: 28812.0,
    app_flat_13: 32,
    char_14: 'sparkle',
    app_rate_14: '6.37%',
    avg_round_14: 27271.0,
    app_flat_14: 25,
    char_15: 'fu-xuan',
    app_rate_15: '5.14%',
    avg_round_15: 33727.0,
    app_flat_15: 22,
    char_16: 'herta',
    app_rate_16: '3.8%',
    avg_round_16: 28495,
    app_flat_16: 16,
    char_17: 'jade',
    app_rate_17: '3.6%',
    avg_round_17: 32096.0,
    app_flat_17: 18,
    char_18: 'anaxa',
    app_rate_18: '2.77%',
    avg_round_18: 28247.0,
    app_flat_18: 10,
    char_19: 'jiaoqiu',
    app_rate_19: '2.77%',
    avg_round_19: 26608,
    app_flat_19: 5,
    char_20: 'tingyun-fugue',
    app_rate_20: '2.16%',
    avg_round_20: 26920,
    app_flat_20: 2,
    char_21: 'mydei',
    app_rate_21: '1.54%',
    avg_round_21: 26424,
    app_flat_21: 5,
    char_22: 'himeko',
    app_rate_22: '1.03%',
    avg_round_22: 24067.0,
    app_flat_22: 5,
    char_23: 'yunli',
    app_rate_23: '0.62%',
    avg_round_23: 24600.0,
    app_flat_23: 5,
    char_24: 'trailblazer-harmony',
    app_rate_24: '0.51%',
    avg_round_24: 29580,
    app_flat_24: 2,
    char_25: 'hanya',
    app_rate_25: '0.41%',
    avg_round_25: 25573.0,
    app_flat_25: 3,
    char_26: 'clara',
    app_rate_26: '0.41%',
    avg_round_26: 24400,
    app_flat_26: 1,
    char_27: 'rappa',
    app_rate_27: '0.31%',
    avg_round_27: 21560,
    app_flat_27: 1,
    char_28: 'acheron',
    app_rate_28: '0.21%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'gepard',
    app_rate_29: '0.21%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'boothill',
    app_rate_30: '0.21%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'pela',
    app: 6.44,
    char_1: 'acheron',
    app_rate_1: '75.75%',
    avg_round_1: 27935.0,
    app_flat_1: 315,
    char_2: 'jiaoqiu',
    app_rate_2: '48.73%',
    avg_round_2: 28415.0,
    app_flat_2: 277,
    char_3: 'aventurine',
    app_rate_3: '40.86%',
    avg_round_3: 28255.0,
    app_flat_3: 186,
    char_4: 'fu-xuan',
    app_rate_4: '17.5%',
    avg_round_4: 28005.0,
    app_flat_4: 53,
    char_5: 'gallagher',
    app_rate_5: '17.39%',
    avg_round_5: 27256.0,
    app_flat_5: 85,
    char_6: 'castorice',
    app_rate_6: '15.39%',
    avg_round_6: 27338.0,
    app_flat_6: 54,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '13.29%',
    avg_round_7: 27884.0,
    app_flat_7: 48,
    char_8: 'tribbie',
    app_rate_8: '9.19%',
    avg_round_8: 32144,
    app_flat_8: 20,
    char_9: 'sparkle',
    app_rate_9: '8.19%',
    avg_round_9: 23240,
    app_flat_9: 3,
    char_10: 'sunday',
    app_rate_10: '6.2%',
    avg_round_10: 26831.0,
    app_flat_10: 9,
    char_11: 'luocha',
    app_rate_11: '5.87%',
    avg_round_11: 26880.0,
    app_flat_11: 18,
    char_12: 'lingsha',
    app_rate_12: '5.76%',
    avg_round_12: 30602.0,
    app_flat_12: 24,
    char_13: 'herta',
    app_rate_13: '5.54%',
    avg_round_13: 34074.0,
    app_flat_13: 28,
    char_14: 'the-herta',
    app_rate_14: '4.87%',
    avg_round_14: 34538.0,
    app_flat_14: 29,
    char_15: 'ruan-mei',
    app_rate_15: '3.65%',
    avg_round_15: 26300.0,
    app_flat_15: 6,
    char_16: 'robin',
    app_rate_16: '3.32%',
    avg_round_16: 25930.0,
    app_flat_16: 6,
    char_17: 'huohuo',
    app_rate_17: '2.99%',
    avg_round_17: 27609.0,
    app_flat_17: 14,
    char_18: 'bronya',
    app_rate_18: '2.77%',
    avg_round_18: 26200,
    app_flat_18: 2,
    char_19: 'silver-wolf',
    app_rate_19: '1.66%',
    avg_round_19: 23616.0,
    app_flat_19: 9,
    char_20: 'tingyun-fugue',
    app_rate_20: '1.66%',
    avg_round_20: 24888,
    app_flat_20: 5,
    char_21: 'black-swan',
    app_rate_21: '1.33%',
    avg_round_21: 22408,
    app_flat_21: 5,
    char_22: 'gepard',
    app_rate_22: '1.22%',
    avg_round_22: 24820.0,
    app_flat_22: 4,
    char_23: 'mydei',
    app_rate_23: '1.0%',
    avg_round_23: 27570,
    app_flat_23: 4,
    char_24: 'kafka',
    app_rate_24: '0.89%',
    avg_round_24: 26173.0,
    app_flat_24: 3,
    char_25: 'jade',
    app_rate_25: '0.78%',
    avg_round_25: 32260,
    app_flat_25: 2,
    char_26: 'anaxa',
    app_rate_26: '0.66%',
    avg_round_26: 31060,
    app_flat_26: 2,
    char_27: 'march-7th',
    app_rate_27: '0.55%',
    avg_round_27: 27040,
    app_flat_27: 2,
    char_28: 'bailu',
    app_rate_28: '0.55%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'rappa',
    app_rate_29: '0.33%',
    avg_round_29: 25220,
    app_flat_29: 2,
    char_30: 'aglaea',
    app_rate_30: '0.22%',
    avg_round_30: 28880,
    app_flat_30: 2
  },
  {
    char: 'trailblazer-harmony',
    app: 6.43,
    char_1: 'ruan-mei',
    app_rate_1: '88.03%',
    avg_round_1: 26877.0,
    app_flat_1: 132,
    char_2: 'tingyun-fugue',
    app_rate_2: '57.54%',
    avg_round_2: 33526.0,
    app_flat_2: 61,
    char_3: 'rappa',
    app_rate_3: '49.11%',
    avg_round_3: 29148.0,
    app_flat_3: 138,
    char_4: 'firefly',
    app_rate_4: '42.68%',
    avg_round_4: 24593.0,
    app_flat_4: 12,
    char_5: 'lingsha',
    app_rate_5: '34.37%',
    avg_round_5: 27367.0,
    app_flat_5: 46,
    char_6: 'gallagher',
    app_rate_6: '19.96%',
    avg_round_6: 24368.0,
    app_flat_6: 48,
    char_7: 'himeko',
    app_rate_7: '2.66%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'luocha',
    app_rate_8: '2.55%',
    avg_round_8: 23000,
    app_flat_8: 8,
    char_9: 'aventurine',
    app_rate_9: '1.88%',
    avg_round_9: 22776,
    app_flat_9: 5,
    char_10: 'huohuo',
    app_rate_10: '1.33%',
    avg_round_10: 24500,
    app_flat_10: 2,
    char_11: 'bronya',
    app_rate_11: '0.67%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'sunday',
    app_rate_12: '0.67%',
    avg_round_12: 24040,
    app_flat_12: 1,
    char_13: 'argenti',
    app_rate_13: '0.55%',
    avg_round_13: 29580,
    app_flat_13: 2,
    char_14: 'tribbie',
    app_rate_14: '0.44%',
    avg_round_14: 33320,
    app_flat_14: 3,
    char_15: 'herta',
    app_rate_15: '0.44%',
    avg_round_15: 29520,
    app_flat_15: 2,
    char_16: 'castorice',
    app_rate_16: '0.44%',
    avg_round_16: 24580,
    app_flat_16: 2,
    char_17: 'anaxa',
    app_rate_17: '0.33%',
    avg_round_17: 21760,
    app_flat_17: 1,
    char_18: 'mydei',
    app_rate_18: '0.22%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'fu-xuan',
    app_rate_19: '0.22%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'clara',
    app_rate_20: '0.22%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'welt',
    app_rate_21: '0.11%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'asta',
    app_rate_22: '0.11%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'the-herta',
    app_rate_23: '0.11%',
    avg_round_23: 32160,
    app_flat_23: 1,
    char_24: 'luka',
    app_rate_24: '0.11%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'pela',
    app_rate_25: '0.11%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'blade',
    app_rate_26: '0.11%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'jiaoqiu',
    app_rate_27: '0.11%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'gepard',
    app_rate_28: '0.11%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'boothill',
    app_rate_29: '0.11%',
    avg_round_29: 24000,
    app_flat_29: 1,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'bronya',
    app: 5.1,
    char_1: 'mydei',
    app_rate_1: '29.75%',
    avg_round_1: 29373.0,
    app_flat_1: 108,
    char_2: 'sunday',
    app_rate_2: '28.63%',
    avg_round_2: 30794.0,
    app_flat_2: 91,
    char_3: 'acheron',
    app_rate_3: '20.53%',
    avg_round_3: 27872,
    app_flat_3: 5,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '18.72%',
    avg_round_4: 31004.0,
    app_flat_4: 65,
    char_5: 'luocha',
    app_rate_5: '17.74%',
    avg_round_5: 28787.0,
    app_flat_5: 57,
    char_6: 'jiaoqiu',
    app_rate_6: '17.18%',
    avg_round_6: 28737.0,
    app_flat_6: 7,
    char_7: 'robin',
    app_rate_7: '16.9%',
    avg_round_7: 30761,
    app_flat_7: 40,
    char_8: 'aventurine',
    app_rate_8: '14.53%',
    avg_round_8: 31905.0,
    app_flat_8: 22,
    char_9: 'anaxa',
    app_rate_9: '13.83%',
    avg_round_9: 33281.0,
    app_flat_9: 44,
    char_10: 'gallagher',
    app_rate_10: '13.55%',
    avg_round_10: 29210.0,
    app_flat_10: 39,
    char_11: 'ruan-mei',
    app_rate_11: '12.71%',
    avg_round_11: 27480,
    app_flat_11: 23,
    char_12: 'huohuo',
    app_rate_12: '9.64%',
    avg_round_12: 30408.0,
    app_flat_12: 43,
    char_13: 'argenti',
    app_rate_13: '9.22%',
    avg_round_13: 28812.0,
    app_flat_13: 32,
    char_14: 'tribbie',
    app_rate_14: '8.1%',
    avg_round_14: 32805,
    app_flat_14: 24,
    char_15: 'fu-xuan',
    app_rate_15: '7.68%',
    avg_round_15: 31853.0,
    app_flat_15: 12,
    char_16: 'herta',
    app_rate_16: '7.12%',
    avg_round_16: 33072.0,
    app_flat_16: 26,
    char_17: 'the-herta',
    app_rate_17: '6.98%',
    avg_round_17: 38131.0,
    app_flat_17: 26,
    char_18: 'castorice',
    app_rate_18: '6.15%',
    avg_round_18: 29769.0,
    app_flat_18: 23,
    char_19: 'aglaea',
    app_rate_19: '5.73%',
    avg_round_19: 26680,
    app_flat_19: 6,
    char_20: 'lingsha',
    app_rate_20: '5.59%',
    avg_round_20: 29449.0,
    app_flat_20: 14,
    char_21: 'jade',
    app_rate_21: '3.91%',
    avg_round_21: 39007.0,
    app_flat_21: 12,
    char_22: 'sparkle',
    app_rate_22: '3.77%',
    avg_round_22: 27680,
    app_flat_22: 14,
    char_23: 'tingyun-fugue',
    app_rate_23: '3.77%',
    avg_round_23: 26340,
    app_flat_23: 2,
    char_24: 'pela',
    app_rate_24: '3.49%',
    avg_round_24: 26200,
    app_flat_24: 2,
    char_25: 'firefly',
    app_rate_25: '2.51%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'tingyun',
    app_rate_26: '1.82%',
    avg_round_26: 27760.0,
    app_flat_26: 9,
    char_27: 'jing-yuan',
    app_rate_27: '1.54%',
    avg_round_27: 24240,
    app_flat_27: 1,
    char_28: 'silver-wolf',
    app_rate_28: '0.98%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'trailblazer-harmony',
    app_rate_29: '0.84%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'clara',
    app_rate_30: '0.84%',
    avg_round_30: 24893.0,
    app_flat_30: 3
  },
  {
    char: 'yunli',
    app: 3.66,
    char_1: 'robin',
    app_rate_1: '73.54%',
    avg_round_1: 24904.0,
    app_flat_1: 160,
    char_2: 'huohuo',
    app_rate_2: '43.19%',
    avg_round_2: 24813.0,
    app_flat_2: 81,
    char_3: 'sunday',
    app_rate_3: '28.02%',
    avg_round_3: 24604.0,
    app_flat_3: 63,
    char_4: 'aventurine',
    app_rate_4: '17.9%',
    avg_round_4: 25371,
    app_flat_4: 40,
    char_5: 'tribbie',
    app_rate_5: '16.54%',
    avg_round_5: 30299.0,
    app_flat_5: 30,
    char_6: 'trailblazer-remembrance',
    app_rate_6: '16.34%',
    avg_round_6: 26526,
    app_flat_6: 40,
    char_7: 'sparkle',
    app_rate_7: '14.4%',
    avg_round_7: 24530,
    app_flat_7: 8,
    char_8: 'tingyun',
    app_rate_8: '11.09%',
    avg_round_8: 24143.0,
    app_flat_8: 26,
    char_9: 'fu-xuan',
    app_rate_9: '8.17%',
    avg_round_9: 24500,
    app_flat_9: 12,
    char_10: 'herta',
    app_rate_10: '7.0%',
    avg_round_10: 29744,
    app_flat_10: 15,
    char_11: 'clara',
    app_rate_11: '6.61%',
    avg_round_11: 24408,
    app_flat_11: 20,
    char_12: 'luocha',
    app_rate_12: '6.42%',
    avg_round_12: 24400.0,
    app_flat_12: 14,
    char_13: 'gallagher',
    app_rate_13: '6.03%',
    avg_round_13: 24618.0,
    app_flat_13: 21,
    char_14: 'lingsha',
    app_rate_14: '6.03%',
    avg_round_14: 25695,
    app_flat_14: 16,
    char_15: 'jade',
    app_rate_15: '5.06%',
    avg_round_15: 28480.0,
    app_flat_15: 11,
    char_16: 'ruan-mei',
    app_rate_16: '5.06%',
    avg_round_16: 24080,
    app_flat_16: 6,
    char_17: 'castorice',
    app_rate_17: '3.89%',
    avg_round_17: 26255.0,
    app_flat_17: 13,
    char_18: 'feixiao',
    app_rate_18: '3.89%',
    avg_round_18: 26914.0,
    app_flat_18: 7,
    char_19: 'mydei',
    app_rate_19: '2.72%',
    avg_round_19: 24300.0,
    app_flat_19: 8,
    char_20: 'acheron',
    app_rate_20: '2.14%',
    avg_round_20: 28413.0,
    app_flat_20: 3,
    char_21: 'tingyun-fugue',
    app_rate_21: '1.75%',
    avg_round_21: 24800.0,
    app_flat_21: 5,
    char_22: 'lynx',
    app_rate_22: '1.75%',
    avg_round_22: 23660.0,
    app_flat_22: 6,
    char_23: 'topaz',
    app_rate_23: '1.75%',
    avg_round_23: 24770,
    app_flat_23: 4,
    char_24: 'jiaoqiu',
    app_rate_24: '1.36%',
    avg_round_24: 25660,
    app_flat_24: 2,
    char_25: 'march-7th-swordmaster',
    app_rate_25: '1.36%',
    avg_round_25: 24290,
    app_flat_25: 4,
    char_26: 'argenti',
    app_rate_26: '1.17%',
    avg_round_26: 24600.0,
    app_flat_26: 5,
    char_27: 'the-herta',
    app_rate_27: '0.97%',
    avg_round_27: 34880,
    app_flat_27: 2,
    char_28: 'rappa',
    app_rate_28: '0.97%',
    avg_round_28: 22227.0,
    app_flat_28: 3,
    char_29: 'bronya',
    app_rate_29: '0.78%',
    avg_round_29: 21320,
    app_flat_29: 1,
    char_30: 'bailu',
    app_rate_30: '0.78%',
    avg_round_30: 25080,
    app_flat_30: 1
  },
  {
    char: 'serval',
    app: 3.64,
    char_1: 'the-herta',
    app_rate_1: '98.04%',
    avg_round_1: 37983.0,
    app_flat_1: 261,
    char_2: 'tribbie',
    app_rate_2: '43.14%',
    avg_round_2: 39966.0,
    app_flat_2: 102,
    char_3: 'trailblazer-remembrance',
    app_rate_3: '21.96%',
    avg_round_3: 37273.0,
    app_flat_3: 67,
    char_4: 'aventurine',
    app_rate_4: '21.57%',
    avg_round_4: 35780,
    app_flat_4: 66,
    char_5: 'huohuo',
    app_rate_5: '21.37%',
    avg_round_5: 37840.0,
    app_flat_5: 56,
    char_6: 'sunday',
    app_rate_6: '20.78%',
    avg_round_6: 36856.0,
    app_flat_6: 67,
    char_7: 'lingsha',
    app_rate_7: '20.39%',
    avg_round_7: 39168.0,
    app_flat_7: 61,
    char_8: 'robin',
    app_rate_8: '14.71%',
    avg_round_8: 32101.0,
    app_flat_8: 30,
    char_9: 'gallagher',
    app_rate_9: '11.76%',
    avg_round_9: 38819.0,
    app_flat_9: 33,
    char_10: 'fu-xuan',
    app_rate_10: '11.57%',
    avg_round_10: 35270,
    app_flat_10: 24,
    char_11: 'herta',
    app_rate_11: '4.31%',
    avg_round_11: 31926.0,
    app_flat_11: 13,
    char_12: 'ruan-mei',
    app_rate_12: '3.14%',
    avg_round_12: 30696,
    app_flat_12: 5,
    char_13: 'luocha',
    app_rate_13: '2.94%',
    avg_round_13: 35705,
    app_flat_13: 8,
    char_14: 'sparkle',
    app_rate_14: '1.37%',
    avg_round_14: 28960,
    app_flat_14: 2,
    char_15: 'bronya',
    app_rate_15: '0.59%',
    avg_round_15: 24080,
    app_flat_15: 1,
    char_16: 'feixiao',
    app_rate_16: '0.2%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'himeko',
    app_rate_17: '0.2%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'acheron',
    app_rate_18: '0.2%',
    avg_round_18: 24160,
    app_flat_18: 1,
    char_19: 'pela',
    app_rate_19: '0.2%',
    avg_round_19: 24160,
    app_flat_19: 1,
    char_20: 'march-7th',
    app_rate_20: '0.2%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'jade',
    app_rate_21: '0.2%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'asta',
    app_rate_22: '0.2%',
    avg_round_22: 24040,
    app_flat_22: 1,
    char_23: 'hanya',
    app_rate_23: '0.2%',
    avg_round_23: 24040,
    app_flat_23: 1,
    char_24: 'lynx',
    app_rate_24: '0.2%',
    avg_round_24: 24040,
    app_flat_24: 1,
    char_25: 'bailu',
    app_rate_25: '0.2%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'tingyun',
    app_rate_26: '0.2%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'jing-yuan',
    app: 3.56,
    char_1: 'sunday',
    app_rate_1: '96.8%',
    avg_round_1: 28763.0,
    app_flat_1: 147,
    char_2: 'robin',
    app_rate_2: '66.4%',
    avg_round_2: 27987.0,
    app_flat_2: 112,
    char_3: 'aventurine',
    app_rate_3: '42.4%',
    avg_round_3: 27258.0,
    app_flat_3: 64,
    char_4: 'huohuo',
    app_rate_4: '27.8%',
    avg_round_4: 30423.0,
    app_flat_4: 49,
    char_5: 'tribbie',
    app_rate_5: '12.2%',
    avg_round_5: 33371.0,
    app_flat_5: 18,
    char_6: 'fu-xuan',
    app_rate_6: '9.4%',
    avg_round_6: 29373.0,
    app_flat_6: 12,
    char_7: 'gallagher',
    app_rate_7: '7.8%',
    avg_round_7: 28966.0,
    app_flat_7: 11,
    char_8: 'luocha',
    app_rate_8: '5.4%',
    avg_round_8: 30098.0,
    app_flat_8: 9,
    char_9: 'ruan-mei',
    app_rate_9: '5.0%',
    avg_round_9: 26700,
    app_flat_9: 6,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '4.4%',
    avg_round_10: 26560.0,
    app_flat_10: 7,
    char_11: 'tingyun',
    app_rate_11: '3.8%',
    avg_round_11: 30027.0,
    app_flat_11: 3,
    char_12: 'sparkle',
    app_rate_12: '3.2%',
    avg_round_12: 24360,
    app_flat_12: 1,
    char_13: 'bronya',
    app_rate_13: '2.2%',
    avg_round_13: 24240,
    app_flat_13: 1,
    char_14: 'jiaoqiu',
    app_rate_14: '2.0%',
    avg_round_14: 26600,
    app_flat_14: 1,
    char_15: 'lingsha',
    app_rate_15: '2.0%',
    avg_round_15: 27180,
    app_flat_15: 2,
    char_16: 'herta',
    app_rate_16: '1.8%',
    avg_round_16: 27576,
    app_flat_16: 5,
    char_17: 'anaxa',
    app_rate_17: '1.6%',
    avg_round_17: 26940,
    app_flat_17: 2,
    char_18: 'the-herta',
    app_rate_18: '1.4%',
    avg_round_18: 34300,
    app_flat_18: 2,
    char_19: 'jade',
    app_rate_19: '1.0%',
    avg_round_19: 22040,
    app_flat_19: 1,
    char_20: 'clara',
    app_rate_20: '0.6%',
    avg_round_20: 23760,
    app_flat_20: 1,
    char_21: 'castorice',
    app_rate_21: '0.4%',
    avg_round_21: 29760,
    app_flat_21: 1,
    char_22: 'tingyun-fugue',
    app_rate_22: '0.4%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'pela',
    app_rate_23: '0.4%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'hanya',
    app_rate_24: '0.2%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'yunli',
    app_rate_25: '0.2%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'himeko',
    app_rate_26: '0.2%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'asta',
    app_rate_27: '0.2%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'gepard',
    app_rate_28: '0.2%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'misha',
    app_rate_29: '0.2%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'mydei',
    app_rate_30: '0.2%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'himeko',
    app: 2.96,
    char_1: 'ruan-mei',
    app_rate_1: '63.61%',
    avg_round_1: 25952.0,
    app_flat_1: 46,
    char_2: 'tingyun-fugue',
    app_rate_2: '60.72%',
    avg_round_2: 25316.0,
    app_flat_2: 38,
    char_3: 'herta',
    app_rate_3: '28.19%',
    avg_round_3: 26428.0,
    app_flat_3: 52,
    char_4: 'firefly',
    app_rate_4: '25.54%',
    avg_round_4: 24728,
    app_flat_4: 10,
    char_5: 'lingsha',
    app_rate_5: '14.94%',
    avg_round_5: 26932.0,
    app_flat_5: 20,
    char_6: 'aventurine',
    app_rate_6: '14.7%',
    avg_round_6: 25411.0,
    app_flat_6: 27,
    char_7: 'robin',
    app_rate_7: '12.77%',
    avg_round_7: 24975.0,
    app_flat_7: 25,
    char_8: 'the-herta',
    app_rate_8: '12.53%',
    avg_round_8: 33947.0,
    app_flat_8: 27,
    char_9: 'gallagher',
    app_rate_9: '9.4%',
    avg_round_9: 24211.0,
    app_flat_9: 13,
    char_10: 'tribbie',
    app_rate_10: '9.16%',
    avg_round_10: 31673.0,
    app_flat_10: 11,
    char_11: 'rappa',
    app_rate_11: '6.51%',
    avg_round_11: 29768,
    app_flat_11: 5,
    char_12: 'trailblazer-harmony',
    app_rate_12: '5.78%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'fu-xuan',
    app_rate_13: '4.82%',
    avg_round_13: 29206.0,
    app_flat_13: 7,
    char_14: 'huohuo',
    app_rate_14: '4.58%',
    avg_round_14: 28790,
    app_flat_14: 8,
    char_15: 'trailblazer-remembrance',
    app_rate_15: '3.86%',
    avg_round_15: 32384,
    app_flat_15: 5,
    char_16: 'acheron',
    app_rate_16: '3.13%',
    avg_round_16: 23720.0,
    app_flat_16: 4,
    char_17: 'luocha',
    app_rate_17: '2.89%',
    avg_round_17: 24200.0,
    app_flat_17: 5,
    char_18: 'anaxa',
    app_rate_18: '2.89%',
    avg_round_18: 28352,
    app_flat_18: 5,
    char_19: 'argenti',
    app_rate_19: '2.41%',
    avg_round_19: 24067.0,
    app_flat_19: 5,
    char_20: 'sunday',
    app_rate_20: '1.69%',
    avg_round_20: 31504,
    app_flat_20: 5,
    char_21: 'jiaoqiu',
    app_rate_21: '1.2%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'clara',
    app_rate_22: '1.2%',
    avg_round_22: 22573.0,
    app_flat_22: 3,
    char_23: 'jade',
    app_rate_23: '1.2%',
    avg_round_23: 29100,
    app_flat_23: 2,
    char_24: 'sparkle',
    app_rate_24: '0.96%',
    avg_round_24: 24040,
    app_flat_24: 1,
    char_25: 'castorice',
    app_rate_25: '0.72%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'yunli',
    app_rate_26: '0.48%',
    avg_round_26: 23120,
    app_flat_26: 1,
    char_27: 'bronya',
    app_rate_27: '0.48%',
    avg_round_27: 24000,
    app_flat_27: 1,
    char_28: 'pela',
    app_rate_28: '0.48%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'mydei',
    app_rate_29: '0.48%',
    avg_round_29: 24020,
    app_flat_29: 2,
    char_30: 'kafka',
    app_rate_30: '0.48%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'black-swan',
    app: 2.55,
    char_1: 'acheron',
    app_rate_1: '74.3%',
    avg_round_1: 25558.0,
    app_flat_1: 108,
    char_2: 'kafka',
    app_rate_2: '71.51%',
    avg_round_2: 25162.0,
    app_flat_2: 63,
    char_3: 'aventurine',
    app_rate_3: '32.12%',
    avg_round_3: 25649.0,
    app_flat_3: 49,
    char_4: 'huohuo',
    app_rate_4: '21.23%',
    avg_round_4: 24778.0,
    app_flat_4: 9,
    char_5: 'jiaoqiu',
    app_rate_5: '17.88%',
    avg_round_5: 26687.0,
    app_flat_5: 39,
    char_6: 'fu-xuan',
    app_rate_6: '14.53%',
    avg_round_6: 25195.0,
    app_flat_6: 22,
    char_7: 'robin',
    app_rate_7: '12.85%',
    avg_round_7: 25360,
    app_flat_7: 2,
    char_8: 'ruan-mei',
    app_rate_8: '12.57%',
    avg_round_8: 24160,
    app_flat_8: 1,
    char_9: 'gallagher',
    app_rate_9: '10.89%',
    avg_round_9: 26142.0,
    app_flat_9: 13,
    char_10: 'lingsha',
    app_rate_10: '6.7%',
    avg_round_10: 26585,
    app_flat_10: 8,
    char_11: 'luocha',
    app_rate_11: '4.75%',
    avg_round_11: 25147.0,
    app_flat_11: 3,
    char_12: 'gepard',
    app_rate_12: '3.91%',
    avg_round_12: 25040,
    app_flat_12: 6,
    char_13: 'pela',
    app_rate_13: '3.35%',
    avg_round_13: 22408,
    app_flat_13: 5,
    char_14: 'tribbie',
    app_rate_14: '3.07%',
    avg_round_14: 26020,
    app_flat_14: 2,
    char_15: 'bailu',
    app_rate_15: '1.68%',
    avg_round_15: 24120,
    app_flat_15: 2,
    char_16: 'sunday',
    app_rate_16: '1.4%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'sparkle',
    app_rate_17: '1.12%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'tingyun',
    app_rate_18: '0.84%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'herta',
    app_rate_19: '0.84%',
    avg_round_19: 24080,
    app_flat_19: 1,
    char_20: 'castorice',
    app_rate_20: '0.56%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'yunli',
    app_rate_21: '0.56%',
    avg_round_21: 24080,
    app_flat_21: 1,
    char_22: 'tingyun-fugue',
    app_rate_22: '0.56%',
    avg_round_22: 24080,
    app_flat_22: 1,
    char_23: 'mydei',
    app_rate_23: '0.56%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'trailblazer-remembrance',
    app_rate_24: '0.28%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'asta',
    app_rate_25: '0.28%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'bronya',
    app_rate_26: '0.28%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'guinaifen',
    app_rate_27: '0.28%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'feixiao',
    app_rate_28: '0.28%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'clara',
    app_rate_29: '0.28%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'sampo',
    app_rate_30: '0.28%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'kafka',
    app: 2.43,
    char_1: 'black-swan',
    app_rate_1: '75.07%',
    avg_round_1: 25162.0,
    app_flat_1: 63,
    char_2: 'acheron',
    app_rate_2: '73.61%',
    avg_round_2: 25382.0,
    app_flat_2: 82,
    char_3: 'aventurine',
    app_rate_3: '32.26%',
    avg_round_3: 25611.0,
    app_flat_3: 42,
    char_4: 'huohuo',
    app_rate_4: '21.7%',
    avg_round_4: 24380.0,
    app_flat_4: 6,
    char_5: 'jiaoqiu',
    app_rate_5: '17.3%',
    avg_round_5: 28929.0,
    app_flat_5: 17,
    char_6: 'ruan-mei',
    app_rate_6: '13.49%',
    avg_round_6: 23020,
    app_flat_6: 2,
    char_7: 'robin',
    app_rate_7: '12.9%',
    avg_round_7: 24440,
    app_flat_7: 1,
    char_8: 'fu-xuan',
    app_rate_8: '12.9%',
    avg_round_8: 25495.0,
    app_flat_8: 16,
    char_9: 'gallagher',
    app_rate_9: '10.56%',
    avg_round_9: 27230,
    app_flat_9: 8,
    char_10: 'lingsha',
    app_rate_10: '6.45%',
    avg_round_10: 24080,
    app_flat_10: 2,
    char_11: 'luocha',
    app_rate_11: '5.87%',
    avg_round_11: 24133.0,
    app_flat_11: 3,
    char_12: 'gepard',
    app_rate_12: '3.81%',
    avg_round_12: 26064,
    app_flat_12: 5,
    char_13: 'tribbie',
    app_rate_13: '3.23%',
    avg_round_13: 26020,
    app_flat_13: 2,
    char_14: 'pela',
    app_rate_14: '2.35%',
    avg_round_14: 26173.0,
    app_flat_14: 3,
    char_15: 'bailu',
    app_rate_15: '2.05%',
    avg_round_15: 24120,
    app_flat_15: 2,
    char_16: 'tingyun-fugue',
    app_rate_16: '1.17%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'tingyun',
    app_rate_17: '1.17%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'bronya',
    app_rate_18: '0.88%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'sparkle',
    app_rate_19: '0.59%',
    avg_round_19: 28920,
    app_flat_19: 1,
    char_20: 'herta',
    app_rate_20: '0.59%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'himeko',
    app_rate_21: '0.59%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'sunday',
    app_rate_22: '0.29%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'jade',
    app_rate_23: '0.29%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'guinaifen',
    app_rate_24: '0.29%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'clara',
    app_rate_25: '0.29%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'sampo',
    app_rate_26: '0.29%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'aglaea',
    app: 2.35,
    char_1: 'sunday',
    app_rate_1: '86.02%',
    avg_round_1: 26017.0,
    app_flat_1: 50,
    char_2: 'robin',
    app_rate_2: '76.9%',
    avg_round_2: 25908.0,
    app_flat_2: 43,
    char_3: 'huohuo',
    app_rate_3: '39.51%',
    avg_round_3: 25497.0,
    app_flat_3: 23,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '15.2%',
    avg_round_4: 30407.0,
    app_flat_4: 6,
    char_5: 'tribbie',
    app_rate_5: '14.89%',
    avg_round_5: 33193.0,
    app_flat_5: 6,
    char_6: 'bronya',
    app_rate_6: '12.46%',
    avg_round_6: 26680,
    app_flat_6: 6,
    char_7: 'fu-xuan',
    app_rate_7: '11.25%',
    avg_round_7: 24493.0,
    app_flat_7: 6,
    char_8: 'aventurine',
    app_rate_8: '8.51%',
    avg_round_8: 23960,
    app_flat_8: 3,
    char_9: 'gallagher',
    app_rate_9: '7.9%',
    avg_round_9: 26864,
    app_flat_9: 5,
    char_10: 'lingsha',
    app_rate_10: '6.69%',
    avg_round_10: 26790,
    app_flat_10: 4,
    char_11: 'luocha',
    app_rate_11: '6.08%',
    avg_round_11: 27460,
    app_flat_11: 2,
    char_12: 'ruan-mei',
    app_rate_12: '4.56%',
    avg_round_12: 24200,
    app_flat_12: 1,
    char_13: 'castorice',
    app_rate_13: '2.43%',
    avg_round_13: 29720,
    app_flat_13: 1,
    char_14: 'sparkle',
    app_rate_14: '1.22%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'herta',
    app_rate_15: '1.22%',
    avg_round_15: 22520,
    app_flat_15: 1,
    char_16: 'pela',
    app_rate_16: '0.61%',
    avg_round_16: 28880,
    app_flat_16: 2,
    char_17: 'bailu',
    app_rate_17: '0.61%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'jade',
    app_rate_18: '0.61%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'tingyun-fugue',
    app_rate_19: '0.3%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'acheron',
    app_rate_20: '0.3%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'jiaoqiu',
    app_rate_21: '0.3%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'the-herta',
    app_rate_22: '0.3%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'natasha',
    app_rate_23: '0.3%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'blade',
    app_rate_24: '0.3%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'tingyun',
    app_rate_25: '0.3%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'yunli',
    app_rate_26: '0.3%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'clara',
    app_rate_27: '0.3%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'feixiao',
    app_rate_28: '0.3%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'himeko',
    app_rate_29: '0.3%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'clara',
    app: 1.87,
    char_1: 'robin',
    app_rate_1: '73.28%',
    avg_round_1: 24301.0,
    app_flat_1: 83,
    char_2: 'aventurine',
    app_rate_2: '35.5%',
    avg_round_2: 24189.0,
    app_flat_2: 39,
    char_3: 'huohuo',
    app_rate_3: '25.57%',
    avg_round_3: 24180.0,
    app_flat_3: 30,
    char_4: 'sunday',
    app_rate_4: '23.28%',
    avg_round_4: 24226.0,
    app_flat_4: 31,
    char_5: 'sparkle',
    app_rate_5: '15.27%',
    avg_round_5: 24109.0,
    app_flat_5: 15,
    char_6: 'yunli',
    app_rate_6: '12.98%',
    avg_round_6: 24408,
    app_flat_6: 20,
    char_7: 'tribbie',
    app_rate_7: '10.31%',
    avg_round_7: 26960.0,
    app_flat_7: 7,
    char_8: 'luocha',
    app_rate_8: '9.92%',
    avg_round_8: 24991.0,
    app_flat_8: 14,
    char_9: 'herta',
    app_rate_9: '9.92%',
    avg_round_9: 25526.0,
    app_flat_9: 11,
    char_10: 'trailblazer-remembrance',
    app_rate_10: '9.16%',
    avg_round_10: 26120.0,
    app_flat_10: 12,
    char_11: 'gallagher',
    app_rate_11: '7.25%',
    avg_round_11: 24667.0,
    app_flat_11: 10,
    char_12: 'lingsha',
    app_rate_12: '6.87%',
    avg_round_12: 26063.0,
    app_flat_12: 11,
    char_13: 'tingyun',
    app_rate_13: '6.11%',
    avg_round_13: 23929.0,
    app_flat_13: 9,
    char_14: 'castorice',
    app_rate_14: '5.73%',
    avg_round_14: 26156.0,
    app_flat_14: 11,
    char_15: 'ruan-mei',
    app_rate_15: '5.73%',
    avg_round_15: 25960,
    app_flat_15: 3,
    char_16: 'jade',
    app_rate_16: '5.34%',
    avg_round_16: 24930.0,
    app_flat_16: 6,
    char_17: 'fu-xuan',
    app_rate_17: '4.96%',
    avg_round_17: 23152,
    app_flat_17: 5,
    char_18: 'mydei',
    app_rate_18: '4.2%',
    avg_round_18: 25022.0,
    app_flat_18: 9,
    char_19: 'march-7th-swordmaster',
    app_rate_19: '3.44%',
    avg_round_19: 24380,
    app_flat_19: 4,
    char_20: 'feixiao',
    app_rate_20: '3.44%',
    avg_round_20: 26400,
    app_flat_20: 2,
    char_21: 'bronya',
    app_rate_21: '2.29%',
    avg_round_21: 24893.0,
    app_flat_21: 3,
    char_22: 'acheron',
    app_rate_22: '2.29%',
    avg_round_22: 22260,
    app_flat_22: 2,
    char_23: 'himeko',
    app_rate_23: '1.91%',
    avg_round_23: 22573.0,
    app_flat_23: 3,
    char_24: 'blade',
    app_rate_24: '1.53%',
    avg_round_24: 22920,
    app_flat_24: 2,
    char_25: 'topaz',
    app_rate_25: '1.53%',
    avg_round_25: 23093.0,
    app_flat_25: 3,
    char_26: 'argenti',
    app_rate_26: '1.53%',
    avg_round_26: 24400,
    app_flat_26: 1,
    char_27: 'lynx',
    app_rate_27: '1.53%',
    avg_round_27: 23227.0,
    app_flat_27: 3,
    char_28: 'jing-yuan',
    app_rate_28: '1.15%',
    avg_round_28: 23760,
    app_flat_28: 1,
    char_29: 'imbibitor-lunae',
    app_rate_29: '1.15%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'jiaoqiu',
    app_rate_30: '0.76%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'tingyun',
    app: 1.86,
    char_1: 'argenti',
    app_rate_1: '45.59%',
    avg_round_1: 28155.0,
    app_flat_1: 77,
    char_2: 'sunday',
    app_rate_2: '40.61%',
    avg_round_2: 29326.0,
    app_flat_2: 54,
    char_3: 'huohuo',
    app_rate_3: '35.63%',
    avg_round_3: 26616.0,
    app_flat_3: 54,
    char_4: 'robin',
    app_rate_4: '28.74%',
    avg_round_4: 24571.0,
    app_flat_4: 35,
    char_5: 'yunli',
    app_rate_5: '21.84%',
    avg_round_5: 24143.0,
    app_flat_5: 26,
    char_6: 'aventurine',
    app_rate_6: '18.77%',
    avg_round_6: 27442.0,
    app_flat_6: 26,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '14.18%',
    avg_round_7: 30939.0,
    app_flat_7: 23,
    char_8: 'sparkle',
    app_rate_8: '10.73%',
    avg_round_8: 24620.0,
    app_flat_8: 8,
    char_9: 'jing-yuan',
    app_rate_9: '7.28%',
    avg_round_9: 30027.0,
    app_flat_9: 3,
    char_10: 'fu-xuan',
    app_rate_10: '6.9%',
    avg_round_10: 25547.0,
    app_flat_10: 5,
    char_11: 'anaxa',
    app_rate_11: '6.51%',
    avg_round_11: 33674.0,
    app_flat_11: 7,
    char_12: 'herta',
    app_rate_12: '6.51%',
    avg_round_12: 28300,
    app_flat_12: 10,
    char_13: 'ruan-mei',
    app_rate_13: '6.51%',
    avg_round_13: 29885,
    app_flat_13: 8,
    char_14: 'gallagher',
    app_rate_14: '6.51%',
    avg_round_14: 30315,
    app_flat_14: 8,
    char_15: 'clara',
    app_rate_15: '6.13%',
    avg_round_15: 23929.0,
    app_flat_15: 9,
    char_16: 'luocha',
    app_rate_16: '6.13%',
    avg_round_16: 27085,
    app_flat_16: 8,
    char_17: 'bronya',
    app_rate_17: '4.98%',
    avg_round_17: 27760.0,
    app_flat_17: 9,
    char_18: 'lingsha',
    app_rate_18: '4.98%',
    avg_round_18: 25192,
    app_flat_18: 5,
    char_19: 'tribbie',
    app_rate_19: '4.98%',
    avg_round_19: 34790,
    app_flat_19: 4,
    char_20: 'the-herta',
    app_rate_20: '3.45%',
    avg_round_20: 33547.0,
    app_flat_20: 3,
    char_21: 'jade',
    app_rate_21: '2.68%',
    avg_round_21: 40000,
    app_flat_21: 1,
    char_22: 'kafka',
    app_rate_22: '1.53%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'black-swan',
    app_rate_23: '1.15%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'lynx',
    app_rate_24: '1.15%',
    avg_round_24: 24160,
    app_flat_24: 2,
    char_25: 'tingyun-fugue',
    app_rate_25: '0.77%',
    avg_round_25: 24000,
    app_flat_25: 1,
    char_26: 'bailu',
    app_rate_26: '0.77%',
    avg_round_26: 27840,
    app_flat_26: 1,
    char_27: 'imbibitor-lunae',
    app_rate_27: '0.77%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'jiaoqiu',
    app_rate_28: '0.77%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'mydei',
    app_rate_29: '0.38%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'rappa',
    app_rate_30: '0.38%',
    avg_round_30: 24000,
    app_flat_30: 1
  },
  {
    char: 'feixiao',
    app: 1.51,
    char_1: 'robin',
    app_rate_1: '87.26%',
    avg_round_1: 25666.0,
    app_flat_1: 31,
    char_2: 'aventurine',
    app_rate_2: '67.92%',
    avg_round_2: 25368.0,
    app_flat_2: 26,
    char_3: 'herta',
    app_rate_3: '29.72%',
    avg_round_3: 28256,
    app_flat_3: 10,
    char_4: 'jade',
    app_rate_4: '17.92%',
    avg_round_4: 28860,
    app_flat_4: 2,
    char_5: 'tribbie',
    app_rate_5: '15.57%',
    avg_round_5: 31173.0,
    app_flat_5: 3,
    char_6: 'topaz',
    app_rate_6: '15.57%',
    avg_round_6: 22720,
    app_flat_6: 3,
    char_7: 'march-7th-swordmaster',
    app_rate_7: '10.38%',
    avg_round_7: 22290,
    app_flat_7: 8,
    char_8: 'yunli',
    app_rate_8: '9.43%',
    avg_round_8: 26914.0,
    app_flat_8: 7,
    char_9: 'lingsha',
    app_rate_9: '6.6%',
    avg_round_9: 27360,
    app_flat_9: 4,
    char_10: 'fu-xuan',
    app_rate_10: '5.19%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '4.72%',
    avg_round_11: 25240,
    app_flat_11: 2,
    char_12: 'clara',
    app_rate_12: '4.25%',
    avg_round_12: 26400,
    app_flat_12: 2,
    char_13: 'luocha',
    app_rate_13: '3.3%',
    avg_round_13: 25253.0,
    app_flat_13: 3,
    char_14: 'gallagher',
    app_rate_14: '2.83%',
    avg_round_14: 24520,
    app_flat_14: 1,
    char_15: 'acheron',
    app_rate_15: '2.36%',
    avg_round_15: 24360,
    app_flat_15: 1,
    char_16: 'sunday',
    app_rate_16: '2.36%',
    avg_round_16: 24120,
    app_flat_16: 1,
    char_17: 'sparkle',
    app_rate_17: '1.89%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'castorice',
    app_rate_18: '1.89%',
    avg_round_18: 25740.0,
    app_flat_18: 4,
    char_19: 'huohuo',
    app_rate_19: '1.89%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'ruan-mei',
    app_rate_20: '1.89%',
    avg_round_20: 24680,
    app_flat_20: 1,
    char_21: 'anaxa',
    app_rate_21: '1.42%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'the-herta',
    app_rate_22: '0.94%',
    avg_round_22: 31160,
    app_flat_22: 1,
    char_23: 'serval',
    app_rate_23: '0.47%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'firefly',
    app_rate_24: '0.47%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'himeko',
    app_rate_25: '0.47%',
    avg_round_25: 24720,
    app_flat_25: 1,
    char_26: 'dr-ratio',
    app_rate_26: '0.47%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'argenti',
    app_rate_27: '0.47%',
    avg_round_27: 24520,
    app_flat_27: 1,
    char_28: 'jiaoqiu',
    app_rate_28: '0.47%',
    avg_round_28: 24360,
    app_flat_28: 1,
    char_29: 'mydei',
    app_rate_29: '0.47%',
    avg_round_29: 25680,
    app_flat_29: 1,
    char_30: 'black-swan',
    app_rate_30: '0.47%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'blade',
    app: 1.48,
    char_1: 'castorice',
    app_rate_1: '82.21%',
    avg_round_1: 29618.0,
    app_flat_1: 73,
    char_2: 'tribbie',
    app_rate_2: '43.75%',
    avg_round_2: 33007.0,
    app_flat_2: 38,
    char_3: 'luocha',
    app_rate_3: '39.42%',
    avg_round_3: 28922.0,
    app_flat_3: 32,
    char_4: 'gallagher',
    app_rate_4: '30.29%',
    avg_round_4: 30863.0,
    app_flat_4: 30,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '23.56%',
    avg_round_5: 26265.0,
    app_flat_5: 23,
    char_6: 'ruan-mei',
    app_rate_6: '12.02%',
    avg_round_6: 25400,
    app_flat_6: 6,
    char_7: 'sunday',
    app_rate_7: '10.1%',
    avg_round_7: 27000,
    app_flat_7: 1,
    char_8: 'lingsha',
    app_rate_8: '8.17%',
    avg_round_8: 24920.0,
    app_flat_8: 9,
    char_9: 'robin',
    app_rate_9: '8.17%',
    avg_round_9: 24267.0,
    app_flat_9: 5,
    char_10: 'jade',
    app_rate_10: '7.69%',
    avg_round_10: 26152,
    app_flat_10: 5,
    char_11: 'mydei',
    app_rate_11: '7.21%',
    avg_round_11: 27600,
    app_flat_11: 4,
    char_12: 'huohuo',
    app_rate_12: '7.21%',
    avg_round_12: 28300,
    app_flat_12: 4,
    char_13: 'fu-xuan',
    app_rate_13: '3.85%',
    avg_round_13: 25620,
    app_flat_13: 2,
    char_14: 'sparkle',
    app_rate_14: '2.88%',
    avg_round_14: 22680,
    app_flat_14: 2,
    char_15: 'clara',
    app_rate_15: '1.92%',
    avg_round_15: 22920,
    app_flat_15: 2,
    char_16: 'bronya',
    app_rate_16: '1.92%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'jingliu',
    app_rate_17: '1.92%',
    avg_round_17: 24760,
    app_flat_17: 2,
    char_18: 'jiaoqiu',
    app_rate_18: '1.92%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'lynx',
    app_rate_19: '1.44%',
    avg_round_19: 25800,
    app_flat_19: 2,
    char_20: 'yunli',
    app_rate_20: '1.44%',
    avg_round_20: 24100,
    app_flat_20: 2,
    char_21: 'the-herta',
    app_rate_21: '0.48%',
    avg_round_21: 28760,
    app_flat_21: 1,
    char_22: 'argenti',
    app_rate_22: '0.48%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'trailblazer-harmony',
    app_rate_23: '0.48%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'aglaea',
    app_rate_24: '0.48%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'anaxa',
    app_rate_25: '0.48%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'bailu',
    app_rate_26: '0.48%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'bailu',
    app: 0.8,
    char_1: 'castorice',
    app_rate_1: '45.54%',
    avg_round_1: 31004.0,
    app_flat_1: 18,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '41.07%',
    avg_round_2: 32884.0,
    app_flat_2: 21,
    char_3: 'tribbie',
    app_rate_3: '38.39%',
    avg_round_3: 34369.0,
    app_flat_3: 18,
    char_4: 'the-herta',
    app_rate_4: '26.79%',
    avg_round_4: 38870.0,
    app_flat_4: 16,
    char_5: 'herta',
    app_rate_5: '24.11%',
    avg_round_5: 37529.0,
    app_flat_5: 15,
    char_6: 'ruan-mei',
    app_rate_6: '16.96%',
    avg_round_6: 26030.0,
    app_flat_6: 6,
    char_7: 'sunday',
    app_rate_7: '16.07%',
    avg_round_7: 30070.0,
    app_flat_7: 6,
    char_8: 'robin',
    app_rate_8: '14.29%',
    avg_round_8: 33833.0,
    app_flat_8: 6,
    char_9: 'jade',
    app_rate_9: '10.71%',
    avg_round_9: 37576,
    app_flat_9: 5,
    char_10: 'acheron',
    app_rate_10: '7.14%',
    avg_round_10: 24120,
    app_flat_10: 2,
    char_11: 'sparkle',
    app_rate_11: '7.14%',
    avg_round_11: 25700,
    app_flat_11: 2,
    char_12: 'mydei',
    app_rate_12: '6.25%',
    avg_round_12: 27140,
    app_flat_12: 2,
    char_13: 'kafka',
    app_rate_13: '6.25%',
    avg_round_13: 24120,
    app_flat_13: 2,
    char_14: 'black-swan',
    app_rate_14: '5.36%',
    avg_round_14: 24120,
    app_flat_14: 2,
    char_15: 'pela',
    app_rate_15: '4.46%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'jiaoqiu',
    app_rate_16: '3.57%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'fu-xuan',
    app_rate_17: '3.57%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'yunli',
    app_rate_18: '3.57%',
    avg_round_18: 25080,
    app_flat_18: 1,
    char_19: 'gallagher',
    app_rate_19: '2.68%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'anaxa',
    app_rate_20: '2.68%',
    avg_round_20: 30980,
    app_flat_20: 2,
    char_21: 'aglaea',
    app_rate_21: '1.79%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'bronya',
    app_rate_22: '1.79%',
    avg_round_22: 37880,
    app_flat_22: 1,
    char_23: 'tingyun',
    app_rate_23: '1.79%',
    avg_round_23: 27840,
    app_flat_23: 1,
    char_24: 'lingsha',
    app_rate_24: '0.89%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'qingque',
    app_rate_25: '0.89%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'march-7th-swordmaster',
    app_rate_26: '0.89%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'lynx',
    app_rate_27: '0.89%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'firefly',
    app_rate_28: '0.89%',
    avg_round_28: 0,
    app_flat_28: 0,
    char_29: 'tingyun-fugue',
    app_rate_29: '0.89%',
    avg_round_29: 0,
    app_flat_29: 0,
    char_30: 'jingliu',
    app_rate_30: '0.89%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'silver-wolf',
    app: 0.66,
    char_1: 'acheron',
    app_rate_1: '84.78%',
    avg_round_1: 24634.0,
    app_flat_1: 25,
    char_2: 'aventurine',
    app_rate_2: '40.22%',
    avg_round_2: 24550.0,
    app_flat_2: 16,
    char_3: 'jiaoqiu',
    app_rate_3: '35.87%',
    avg_round_3: 25578.0,
    app_flat_3: 15,
    char_4: 'fu-xuan',
    app_rate_4: '28.26%',
    avg_round_4: 24370,
    app_flat_4: 4,
    char_5: 'sparkle',
    app_rate_5: '20.65%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'pela',
    app_rate_6: '16.3%',
    avg_round_6: 23616.0,
    app_flat_6: 9,
    char_7: 'castorice',
    app_rate_7: '9.78%',
    avg_round_7: 26720,
    app_flat_7: 1,
    char_8: 'gallagher',
    app_rate_8: '9.78%',
    avg_round_8: 26180,
    app_flat_8: 2,
    char_9: 'bronya',
    app_rate_9: '7.61%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'lingsha',
    app_rate_10: '6.52%',
    avg_round_10: 27360,
    app_flat_10: 1,
    char_11: 'luocha',
    app_rate_11: '5.43%',
    avg_round_11: 26200,
    app_flat_11: 2,
    char_12: 'robin',
    app_rate_12: '5.43%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'tribbie',
    app_rate_13: '4.35%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'sunday',
    app_rate_14: '3.26%',
    avg_round_14: 26720,
    app_flat_14: 1,
    char_15: 'gepard',
    app_rate_15: '3.26%',
    avg_round_15: 23600,
    app_flat_15: 1,
    char_16: 'the-herta',
    app_rate_16: '2.17%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'herta',
    app_rate_17: '2.17%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'lynx',
    app_rate_18: '2.17%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'huohuo',
    app_rate_19: '2.17%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'rappa',
    app_rate_20: '1.09%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'tingyun-fugue',
    app_rate_21: '1.09%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'ruan-mei',
    app_rate_22: '1.09%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'trailblazer-remembrance',
    app_rate_23: '1.09%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'mydei',
    app_rate_24: '1.09%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'himeko',
    app_rate_25: '1.09%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'dr-ratio',
    app_rate_26: '1.09%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'boothill',
    app_rate_27: '1.09%',
    avg_round_27: 0,
    app_flat_27: 0,
    char_28: 'black-swan',
    app_rate_28: '1.09%',
    avg_round_28: 23600,
    app_flat_28: 1,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'lynx',
    app: 0.64,
    char_1: 'trailblazer-remembrance',
    app_rate_1: '34.44%',
    avg_round_1: 31920,
    app_flat_1: 15,
    char_2: 'castorice',
    app_rate_2: '31.11%',
    avg_round_2: 30732,
    app_flat_2: 10,
    char_3: 'mydei',
    app_rate_3: '28.89%',
    avg_round_3: 26369.0,
    app_flat_3: 15,
    char_4: 'sunday',
    app_rate_4: '26.67%',
    avg_round_4: 28427.0,
    app_flat_4: 12,
    char_5: 'the-herta',
    app_rate_5: '23.33%',
    avg_round_5: 37916,
    app_flat_5: 10,
    char_6: 'ruan-mei',
    app_rate_6: '23.33%',
    avg_round_6: 27840,
    app_flat_6: 5,
    char_7: 'robin',
    app_rate_7: '21.11%',
    avg_round_7: 24553.0,
    app_flat_7: 12,
    char_8: 'tribbie',
    app_rate_8: '21.11%',
    avg_round_8: 30940,
    app_flat_8: 10,
    char_9: 'jade',
    app_rate_9: '13.33%',
    avg_round_9: 38326.0,
    app_flat_9: 7,
    char_10: 'herta',
    app_rate_10: '13.33%',
    avg_round_10: 33700,
    app_flat_10: 4,
    char_11: 'yunli',
    app_rate_11: '10.0%',
    avg_round_11: 23660.0,
    app_flat_11: 6,
    char_12: 'sparkle',
    app_rate_12: '6.67%',
    avg_round_12: 24400,
    app_flat_12: 1,
    char_13: 'bronya',
    app_rate_13: '6.67%',
    avg_round_13: 24540,
    app_flat_13: 2,
    char_14: 'clara',
    app_rate_14: '4.44%',
    avg_round_14: 23227.0,
    app_flat_14: 3,
    char_15: 'gallagher',
    app_rate_15: '4.44%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'blade',
    app_rate_16: '3.33%',
    avg_round_16: 25800,
    app_flat_16: 2,
    char_17: 'tingyun',
    app_rate_17: '3.33%',
    avg_round_17: 24160,
    app_flat_17: 2,
    char_18: 'fu-xuan',
    app_rate_18: '3.33%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'jiaoqiu',
    app_rate_19: '3.33%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'silver-wolf',
    app_rate_20: '2.22%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'rappa',
    app_rate_21: '2.22%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'tingyun-fugue',
    app_rate_22: '2.22%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'pela',
    app_rate_23: '2.22%',
    avg_round_23: 28960,
    app_flat_23: 1,
    char_24: 'argenti',
    app_rate_24: '1.11%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'bailu',
    app_rate_25: '1.11%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: 'acheron',
    app_rate_26: '1.11%',
    avg_round_26: 0,
    app_flat_26: 0,
    char_27: 'serval',
    app_rate_27: '1.11%',
    avg_round_27: 24040,
    app_flat_27: 1,
    char_28: 'asta',
    app_rate_28: '1.11%',
    avg_round_28: 24040,
    app_flat_28: 1,
    char_29: 'hanya',
    app_rate_29: '1.11%',
    avg_round_29: 24040,
    app_flat_29: 1,
    char_30: 'anaxa',
    app_rate_30: '1.11%',
    avg_round_30: 0,
    app_flat_30: 0
  },
  {
    char: 'imbibitor-lunae',
    app: 0.57,
    char_1: 'sunday',
    app_rate_1: '62.5%',
    avg_round_1: 21040,
    app_flat_1: 1,
    char_2: 'sparkle',
    app_rate_2: '53.75%',
    avg_round_2: 21040,
    app_flat_2: 1,
    char_3: 'robin',
    app_rate_3: '43.75%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'huohuo',
    app_rate_4: '33.75%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'luocha',
    app_rate_5: '26.25%',
    avg_round_5: 21040,
    app_flat_5: 1,
    char_6: 'aventurine',
    app_rate_6: '18.75%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'ruan-mei',
    app_rate_7: '16.25%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'fu-xuan',
    app_rate_8: '7.5%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'tribbie',
    app_rate_9: '7.5%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'gallagher',
    app_rate_10: '7.5%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '5.0%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'clara',
    app_rate_12: '3.75%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'anaxa',
    app_rate_13: '2.5%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'tingyun',
    app_rate_14: '2.5%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'mydei',
    app_rate_15: '2.5%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'yunli',
    app_rate_16: '1.25%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'lingsha',
    app_rate_17: '1.25%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'tingyun-fugue',
    app_rate_18: '1.25%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'jiaoqiu',
    app_rate_19: '1.25%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'argenti',
    app_rate_20: '1.25%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'gepard',
    app: 0.49,
    char_1: 'acheron',
    app_rate_1: '72.46%',
    avg_round_1: 25837.0,
    app_flat_1: 14,
    char_2: 'jiaoqiu',
    app_rate_2: '34.78%',
    avg_round_2: 27640,
    app_flat_2: 6,
    char_3: 'herta',
    app_rate_3: '20.29%',
    avg_round_3: 38267.0,
    app_flat_3: 5,
    char_4: 'black-swan',
    app_rate_4: '20.29%',
    avg_round_4: 25040,
    app_flat_4: 6,
    char_5: 'kafka',
    app_rate_5: '18.84%',
    avg_round_5: 26064,
    app_flat_5: 5,
    char_6: 'sparkle',
    app_rate_6: '18.84%',
    avg_round_6: 24240,
    app_flat_6: 1,
    char_7: 'the-herta',
    app_rate_7: '15.94%',
    avg_round_7: 38700,
    app_flat_7: 4,
    char_8: 'pela',
    app_rate_8: '15.94%',
    avg_round_8: 24820.0,
    app_flat_8: 4,
    char_9: 'sunday',
    app_rate_9: '13.04%',
    avg_round_9: 32300,
    app_flat_9: 2,
    char_10: 'tribbie',
    app_rate_10: '11.59%',
    avg_round_10: 26400,
    app_flat_10: 2,
    char_11: 'robin',
    app_rate_11: '10.14%',
    avg_round_11: 29160,
    app_flat_11: 2,
    char_12: 'ruan-mei',
    app_rate_12: '8.7%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'trailblazer-remembrance',
    app_rate_13: '7.25%',
    avg_round_13: 39547.0,
    app_flat_13: 3,
    char_14: 'bronya',
    app_rate_14: '7.25%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'silver-wolf',
    app_rate_15: '4.35%',
    avg_round_15: 23600,
    app_flat_15: 1,
    char_16: 'jade',
    app_rate_16: '4.35%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'tingyun-fugue',
    app_rate_17: '2.9%',
    avg_round_17: 21320,
    app_flat_17: 1,
    char_18: 'argenti',
    app_rate_18: '2.9%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'clara',
    app_rate_19: '1.45%',
    avg_round_19: 21320,
    app_flat_19: 1,
    char_20: 'gallagher',
    app_rate_20: '1.45%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'firefly',
    app_rate_21: '1.45%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'jing-yuan',
    app_rate_22: '1.45%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: 'rappa',
    app_rate_23: '1.45%',
    avg_round_23: 0,
    app_flat_23: 0,
    char_24: 'trailblazer-harmony',
    app_rate_24: '1.45%',
    avg_round_24: 0,
    app_flat_24: 0,
    char_25: 'anaxa',
    app_rate_25: '1.45%',
    avg_round_25: 0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'topaz',
    app: 0.36,
    char_1: 'robin',
    app_rate_1: '90.0%',
    avg_round_1: 23369.0,
    app_flat_1: 9,
    char_2: 'aventurine',
    app_rate_2: '86.0%',
    avg_round_2: 23611.0,
    app_flat_2: 7,
    char_3: 'feixiao',
    app_rate_3: '66.0%',
    avg_round_3: 22720,
    app_flat_3: 3,
    char_4: 'yunli',
    app_rate_4: '18.0%',
    avg_round_4: 24770,
    app_flat_4: 4,
    char_5: 'huohuo',
    app_rate_5: '10.0%',
    avg_round_5: 23747.0,
    app_flat_5: 3,
    char_6: 'clara',
    app_rate_6: '8.0%',
    avg_round_6: 23093.0,
    app_flat_6: 3,
    char_7: 'tribbie',
    app_rate_7: '6.0%',
    avg_round_7: 26200,
    app_flat_7: 1,
    char_8: 'herta',
    app_rate_8: '4.0%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'jade',
    app_rate_9: '2.0%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'luocha',
    app_rate_10: '2.0%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'lingsha',
    app_rate_11: '2.0%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'the-herta',
    app_rate_12: '2.0%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'acheron',
    app_rate_13: '2.0%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'sunday',
    app_rate_14: '2.0%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'march-7th-swordmaster',
    app: 0.33,
    char_1: 'robin',
    app_rate_1: '78.26%',
    avg_round_1: 23312.0,
    app_flat_1: 16,
    char_2: 'aventurine',
    app_rate_2: '56.52%',
    avg_round_2: 22996.0,
    app_flat_2: 11,
    char_3: 'feixiao',
    app_rate_3: '47.83%',
    avg_round_3: 22290,
    app_flat_3: 8,
    char_4: 'clara',
    app_rate_4: '19.57%',
    avg_round_4: 24380,
    app_flat_4: 4,
    char_5: 'yunli',
    app_rate_5: '15.22%',
    avg_round_5: 24290,
    app_flat_5: 4,
    char_6: 'huohuo',
    app_rate_6: '13.04%',
    avg_round_6: 25350,
    app_flat_6: 4,
    char_7: 'mydei',
    app_rate_7: '10.87%',
    avg_round_7: 24192,
    app_flat_7: 5,
    char_8: 'lingsha',
    app_rate_8: '10.87%',
    avg_round_8: 22880,
    app_flat_8: 1,
    char_9: 'sunday',
    app_rate_9: '8.7%',
    avg_round_9: 25867.0,
    app_flat_9: 3,
    char_10: 'luocha',
    app_rate_10: '8.7%',
    avg_round_10: 22940,
    app_flat_10: 4,
    char_11: 'trailblazer-remembrance',
    app_rate_11: '4.35%',
    avg_round_11: 21680,
    app_flat_11: 2,
    char_12: 'tingyun-fugue',
    app_rate_12: '4.35%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'gallagher',
    app_rate_13: '4.35%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'tribbie',
    app_rate_14: '4.35%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'himeko',
    app_rate_15: '2.17%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'ruan-mei',
    app_rate_16: '2.17%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'bailu',
    app_rate_17: '2.17%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'rappa',
    app_rate_18: '2.17%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'firefly',
    app_rate_19: '2.17%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'fu-xuan',
    app_rate_20: '2.17%',
    avg_round_20: 24960,
    app_flat_20: 1,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'jingliu',
    app: 0.21,
    char_1: 'castorice',
    app_rate_1: '41.38%',
    avg_round_1: 24792,
    app_flat_1: 5,
    char_2: 'tribbie',
    app_rate_2: '37.93%',
    avg_round_2: 28160,
    app_flat_2: 3,
    char_3: 'luocha',
    app_rate_3: '34.48%',
    avg_round_3: 24573.0,
    app_flat_3: 3,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '24.14%',
    avg_round_4: 25100,
    app_flat_4: 4,
    char_5: 'sunday',
    app_rate_5: '20.69%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'gallagher',
    app_rate_6: '20.69%',
    avg_round_6: 24813.0,
    app_flat_6: 3,
    char_7: 'herta',
    app_rate_7: '20.69%',
    avg_round_7: 28747.0,
    app_flat_7: 3,
    char_8: 'bronya',
    app_rate_8: '13.79%',
    avg_round_8: 24200,
    app_flat_8: 1,
    char_9: 'ruan-mei',
    app_rate_9: '13.79%',
    avg_round_9: 25960,
    app_flat_9: 1,
    char_10: 'blade',
    app_rate_10: '13.79%',
    avg_round_10: 24760,
    app_flat_10: 2,
    char_11: 'robin',
    app_rate_11: '10.34%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'huohuo',
    app_rate_12: '10.34%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'lingsha',
    app_rate_13: '6.9%',
    avg_round_13: 26600,
    app_flat_13: 1,
    char_14: 'fu-xuan',
    app_rate_14: '6.9%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'argenti',
    app_rate_15: '3.45%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'the-herta',
    app_rate_16: '3.45%',
    avg_round_16: 33680,
    app_flat_16: 1,
    char_17: 'bailu',
    app_rate_17: '3.45%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'pela',
    app_rate_18: '3.45%',
    avg_round_18: 0,
    app_flat_18: 0,
    char_19: 'trailblazer-preservation',
    app_rate_19: '3.45%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'jade',
    app_rate_20: '3.45%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'jiaoqiu',
    app_rate_21: '3.45%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'welt',
    app: 0.2,
    char_1: 'acheron',
    app_rate_1: '57.14%',
    avg_round_1: 23520,
    app_flat_1: 4,
    char_2: 'jiaoqiu',
    app_rate_2: '42.86%',
    avg_round_2: 25360,
    app_flat_2: 2,
    char_3: 'aventurine',
    app_rate_3: '39.29%',
    avg_round_3: 22820,
    app_flat_3: 2,
    char_4: 'sunday',
    app_rate_4: '25.0%',
    avg_round_4: 27180,
    app_flat_4: 2,
    char_5: 'ruan-mei',
    app_rate_5: '21.43%',
    avg_round_5: 24000,
    app_flat_5: 1,
    char_6: 'tingyun-fugue',
    app_rate_6: '17.86%',
    avg_round_6: 24000,
    app_flat_6: 1,
    char_7: 'robin',
    app_rate_7: '14.29%',
    avg_round_7: 24360,
    app_flat_7: 1,
    char_8: 'fu-xuan',
    app_rate_8: '14.29%',
    avg_round_8: 24220,
    app_flat_8: 2,
    char_9: 'bronya',
    app_rate_9: '7.14%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'tribbie',
    app_rate_10: '7.14%',
    avg_round_10: 30000,
    app_flat_10: 1,
    char_11: 'gallagher',
    app_rate_11: '7.14%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'pela',
    app_rate_12: '7.14%',
    avg_round_12: 21680,
    app_flat_12: 2,
    char_13: 'rappa',
    app_rate_13: '7.14%',
    avg_round_13: 24000,
    app_flat_13: 1,
    char_14: 'himeko',
    app_rate_14: '3.57%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'trailblazer-harmony',
    app_rate_15: '3.57%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'luocha',
    app_rate_16: '3.57%',
    avg_round_16: 24360,
    app_flat_16: 1,
    char_17: 'sparkle',
    app_rate_17: '3.57%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: 'argenti',
    app_rate_18: '3.57%',
    avg_round_18: 30000,
    app_flat_18: 1,
    char_19: 'huohuo',
    app_rate_19: '3.57%',
    avg_round_19: 0,
    app_flat_19: 0,
    char_20: 'anaxa',
    app_rate_20: '3.57%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'the-herta',
    app_rate_21: '3.57%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'herta',
    app_rate_22: '3.57%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'qingque',
    app: 0.17,
    char_1: 'sparkle',
    app_rate_1: '66.67%',
    avg_round_1: 24360.0,
    app_flat_1: 4,
    char_2: 'tribbie',
    app_rate_2: '50.0%',
    avg_round_2: 28453.0,
    app_flat_2: 3,
    char_3: 'fu-xuan',
    app_rate_3: '45.83%',
    avg_round_3: 24080,
    app_flat_3: 1,
    char_4: 'trailblazer-remembrance',
    app_rate_4: '29.17%',
    avg_round_4: 23920,
    app_flat_4: 2,
    char_5: 'the-herta',
    app_rate_5: '20.83%',
    avg_round_5: 30667.0,
    app_flat_5: 3,
    char_6: 'herta',
    app_rate_6: '16.67%',
    avg_round_6: 23680,
    app_flat_6: 1,
    char_7: 'lingsha',
    app_rate_7: '16.67%',
    avg_round_7: 26933.0,
    app_flat_7: 3,
    char_8: 'sunday',
    app_rate_8: '16.67%',
    avg_round_8: 24080,
    app_flat_8: 1,
    char_9: 'ruan-mei',
    app_rate_9: '8.33%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'pela',
    app_rate_10: '4.17%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'bailu',
    app_rate_11: '4.17%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'yunli',
    app_rate_12: '4.17%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'bronya',
    app_rate_13: '4.17%',
    avg_round_13: 24520,
    app_flat_13: 1,
    char_14: 'aventurine',
    app_rate_14: '4.17%',
    avg_round_14: 36200,
    app_flat_14: 1,
    char_15: 'castorice',
    app_rate_15: '4.17%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'luocha',
    app_rate_16: '4.17%',
    avg_round_16: 24160,
    app_flat_16: 1,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'seele',
    app: 0.16,
    char_1: 'robin',
    app_rate_1: '54.55%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'sparkle',
    app_rate_2: '45.45%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'fu-xuan',
    app_rate_3: '40.91%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'sunday',
    app_rate_4: '36.36%',
    avg_round_4: 26240,
    app_flat_4: 1,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '22.73%',
    avg_round_5: 29220,
    app_flat_5: 2,
    char_6: 'herta',
    app_rate_6: '18.18%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'huohuo',
    app_rate_7: '13.64%',
    avg_round_7: 26240,
    app_flat_7: 1,
    char_8: 'tribbie',
    app_rate_8: '13.64%',
    avg_round_8: 32200,
    app_flat_8: 1,
    char_9: 'lingsha',
    app_rate_9: '9.09%',
    avg_round_9: 32200,
    app_flat_9: 1,
    char_10: 'gallagher',
    app_rate_10: '9.09%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'aventurine',
    app_rate_11: '9.09%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'xueyi',
    app_rate_12: '4.55%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'jade',
    app_rate_13: '4.55%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'clara',
    app_rate_14: '4.55%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'tingyun',
    app_rate_15: '4.55%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'bronya',
    app_rate_16: '4.55%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'ruan-mei',
    app_rate_17: '4.55%',
    avg_round_17: 0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'boothill',
    app: 0.15,
    char_1: 'tingyun-fugue',
    app_rate_1: '85.71%',
    avg_round_1: 24940,
    app_flat_1: 2,
    char_2: 'ruan-mei',
    app_rate_2: '61.9%',
    avg_round_2: 25880,
    app_flat_2: 1,
    char_3: 'lingsha',
    app_rate_3: '33.33%',
    avg_round_3: 25880,
    app_flat_3: 1,
    char_4: 'gallagher',
    app_rate_4: '14.29%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'sunday',
    app_rate_5: '14.29%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'rappa',
    app_rate_6: '14.29%',
    avg_round_6: 24000,
    app_flat_6: 1,
    char_7: 'aventurine',
    app_rate_7: '9.52%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'bronya',
    app_rate_8: '9.52%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'acheron',
    app_rate_9: '9.52%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'huohuo',
    app_rate_10: '9.52%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'argenti',
    app_rate_11: '9.52%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'mydei',
    app_rate_12: '4.76%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'jiaoqiu',
    app_rate_13: '4.76%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'tribbie',
    app_rate_14: '4.76%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'dr-ratio',
    app_rate_15: '4.76%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'silver-wolf',
    app_rate_16: '4.76%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'trailblazer-harmony',
    app_rate_17: '4.76%',
    avg_round_17: 24000,
    app_flat_17: 1,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'march-7th',
    app: 0.14,
    char_1: 'acheron',
    app_rate_1: '50.0%',
    avg_round_1: 27053.0,
    app_flat_1: 3,
    char_2: 'herta',
    app_rate_2: '50.0%',
    avg_round_2: 40000.0,
    app_flat_2: 6,
    char_3: 'the-herta',
    app_rate_3: '40.0%',
    avg_round_3: 40000,
    app_flat_3: 5,
    char_4: 'tribbie',
    app_rate_4: '35.0%',
    avg_round_4: 28920,
    app_flat_4: 2,
    char_5: 'pela',
    app_rate_5: '25.0%',
    avg_round_5: 27040,
    app_flat_5: 2,
    char_6: 'jiaoqiu',
    app_rate_6: '20.0%',
    avg_round_6: 27320,
    app_flat_6: 2,
    char_7: 'trailblazer-remembrance',
    app_rate_7: '20.0%',
    avg_round_7: 40000,
    app_flat_7: 3,
    char_8: 'robin',
    app_rate_8: '15.0%',
    avg_round_8: 40000,
    app_flat_8: 1,
    char_9: 'sparkle',
    app_rate_9: '10.0%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'tingyun-fugue',
    app_rate_10: '10.0%',
    avg_round_10: 27080,
    app_flat_10: 1,
    char_11: 'sunday',
    app_rate_11: '5.0%',
    avg_round_11: 40000,
    app_flat_11: 1,
    char_12: 'ruan-mei',
    app_rate_12: '5.0%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'jade',
    app_rate_13: '5.0%',
    avg_round_13: 31320,
    app_flat_13: 1,
    char_14: 'serval',
    app_rate_14: '5.0%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'clara',
    app_rate_15: '5.0%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'xueyi',
    app: 0.11,
    char_1: 'tribbie',
    app_rate_1: '60.0%',
    avg_round_1: 36620,
    app_flat_1: 4,
    char_2: 'herta',
    app_rate_2: '46.67%',
    avg_round_2: 32370,
    app_flat_2: 4,
    char_3: 'fu-xuan',
    app_rate_3: '33.33%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'robin',
    app_rate_4: '26.67%',
    avg_round_4: 32187.0,
    app_flat_4: 3,
    char_5: 'trailblazer-remembrance',
    app_rate_5: '26.67%',
    avg_round_5: 36307.0,
    app_flat_5: 3,
    char_6: 'sparkle',
    app_rate_6: '20.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'the-herta',
    app_rate_7: '20.0%',
    avg_round_7: 37380,
    app_flat_7: 2,
    char_8: 'tingyun-fugue',
    app_rate_8: '13.33%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'jade',
    app_rate_9: '13.33%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'jiaoqiu',
    app_rate_10: '6.67%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'seele',
    app_rate_11: '6.67%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'ruan-mei',
    app_rate_12: '6.67%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'lingsha',
    app_rate_13: '6.67%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'aventurine',
    app_rate_14: '6.67%',
    avg_round_14: 32320,
    app_flat_14: 1,
    char_15: 'gallagher',
    app_rate_15: '6.67%',
    avg_round_15: 22400,
    app_flat_15: 1,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'asta',
    app: 0.11,
    char_1: 'anaxa',
    app_rate_1: '50.0%',
    avg_round_1: 37648,
    app_flat_1: 5,
    char_2: 'trailblazer-remembrance',
    app_rate_2: '31.25%',
    avg_round_2: 37560,
    app_flat_2: 3,
    char_3: 'sunday',
    app_rate_3: '31.25%',
    avg_round_3: 38307.0,
    app_flat_3: 3,
    char_4: 'the-herta',
    app_rate_4: '25.0%',
    avg_round_4: 37620,
    app_flat_4: 2,
    char_5: 'herta',
    app_rate_5: '18.75%',
    avg_round_5: 37620,
    app_flat_5: 2,
    char_6: 'bronya',
    app_rate_6: '18.75%',
    avg_round_6: 36660,
    app_flat_6: 2,
    char_7: 'huohuo',
    app_rate_7: '12.5%',
    avg_round_7: 40000,
    app_flat_7: 2,
    char_8: 'lingsha',
    app_rate_8: '12.5%',
    avg_round_8: 35880,
    app_flat_8: 1,
    char_9: 'gallagher',
    app_rate_9: '12.5%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'aventurine',
    app_rate_10: '12.5%',
    avg_round_10: 34920,
    app_flat_10: 1,
    char_11: 'jade',
    app_rate_11: '6.25%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'firefly',
    app_rate_12: '6.25%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: 'trailblazer-harmony',
    app_rate_13: '6.25%',
    avg_round_13: 0,
    app_flat_13: 0,
    char_14: 'acheron',
    app_rate_14: '6.25%',
    avg_round_14: 0,
    app_flat_14: 0,
    char_15: 'black-swan',
    app_rate_15: '6.25%',
    avg_round_15: 0,
    app_flat_15: 0,
    char_16: 'pela',
    app_rate_16: '6.25%',
    avg_round_16: 0,
    app_flat_16: 0,
    char_17: 'serval',
    app_rate_17: '6.25%',
    avg_round_17: 24040,
    app_flat_17: 1,
    char_18: 'hanya',
    app_rate_18: '6.25%',
    avg_round_18: 24040,
    app_flat_18: 1,
    char_19: 'lynx',
    app_rate_19: '6.25%',
    avg_round_19: 24040,
    app_flat_19: 1,
    char_20: 'jing-yuan',
    app_rate_20: '6.25%',
    avg_round_20: 0,
    app_flat_20: 0,
    char_21: 'robin',
    app_rate_21: '6.25%',
    avg_round_21: 0,
    app_flat_21: 0,
    char_22: 'ruan-mei',
    app_rate_22: '6.25%',
    avg_round_22: 0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'dr-ratio',
    app: 0.05,
    char_1: 'robin',
    app_rate_1: '71.43%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'aventurine',
    app_rate_2: '71.43%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'clara',
    app_rate_3: '28.57%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'feixiao',
    app_rate_4: '14.29%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'moze',
    app_rate_5: '14.29%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'gallagher',
    app_rate_6: '14.29%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'jiaoqiu',
    app_rate_7: '14.29%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'tribbie',
    app_rate_8: '14.29%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'anaxa',
    app_rate_9: '14.29%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'boothill',
    app_rate_10: '14.29%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'silver-wolf',
    app_rate_11: '14.29%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: 'huohuo',
    app_rate_12: '14.29%',
    avg_round_12: 0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hanya',
    app: 0.04,
    char_1: 'argenti',
    app_rate_1: '66.67%',
    avg_round_1: 25573.0,
    app_flat_1: 3,
    char_2: 'sunday',
    app_rate_2: '50.0%',
    avg_round_2: 26260,
    app_flat_2: 2,
    char_3: 'huohuo',
    app_rate_3: '50.0%',
    avg_round_3: 28200,
    app_flat_3: 1,
    char_4: 'jing-yuan',
    app_rate_4: '16.67%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'aventurine',
    app_rate_5: '16.67%',
    avg_round_5: 24320,
    app_flat_5: 1,
    char_6: 'tingyun',
    app_rate_6: '16.67%',
    avg_round_6: 24200,
    app_flat_6: 1,
    char_7: 'lingsha',
    app_rate_7: '16.67%',
    avg_round_7: 24200,
    app_flat_7: 1,
    char_8: 'serval',
    app_rate_8: '16.67%',
    avg_round_8: 24040,
    app_flat_8: 1,
    char_9: 'asta',
    app_rate_9: '16.67%',
    avg_round_9: 24040,
    app_flat_9: 1,
    char_10: 'lynx',
    app_rate_10: '16.67%',
    avg_round_10: 24040,
    app_flat_10: 1,
    char_11: 'ruan-mei',
    app_rate_11: '16.67%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'natasha',
    app: 0.04,
    char_1: 'the-herta',
    app_rate_1: '50.0%',
    avg_round_1: 33760,
    app_flat_1: 2,
    char_2: 'herta',
    app_rate_2: '50.0%',
    avg_round_2: 33760,
    app_flat_2: 2,
    char_3: 'jade',
    app_rate_3: '50.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'tribbie',
    app_rate_4: '50.0%',
    avg_round_4: 40000,
    app_flat_4: 1,
    char_5: 'argenti',
    app_rate_5: '16.67%',
    avg_round_5: 27520,
    app_flat_5: 1,
    char_6: 'castorice',
    app_rate_6: '16.67%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: 'aglaea',
    app_rate_7: '16.67%',
    avg_round_7: 0,
    app_flat_7: 0,
    char_8: 'sunday',
    app_rate_8: '16.67%',
    avg_round_8: 0,
    app_flat_8: 0,
    char_9: 'clara',
    app_rate_9: '16.67%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'robin',
    app_rate_10: '16.67%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'guinaifen',
    app: 0.04,
    char_1: 'acheron',
    app_rate_1: '60.0%',
    avg_round_1: 31360,
    app_flat_1: 1,
    char_2: 'jiaoqiu',
    app_rate_2: '40.0%',
    avg_round_2: 31360,
    app_flat_2: 1,
    char_3: 'lingsha',
    app_rate_3: '40.0%',
    avg_round_3: 24440,
    app_flat_3: 1,
    char_4: 'bronya',
    app_rate_4: '20.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'fu-xuan',
    app_rate_5: '20.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'gallagher',
    app_rate_6: '20.0%',
    avg_round_6: 31360,
    app_flat_6: 1,
    char_7: 'anaxa',
    app_rate_7: '20.0%',
    avg_round_7: 24440,
    app_flat_7: 1,
    char_8: 'trailblazer-remembrance',
    app_rate_8: '20.0%',
    avg_round_8: 24440,
    app_flat_8: 1,
    char_9: 'kafka',
    app_rate_9: '20.0%',
    avg_round_9: 0,
    app_flat_9: 0,
    char_10: 'black-swan',
    app_rate_10: '20.0%',
    avg_round_10: 0,
    app_flat_10: 0,
    char_11: 'aventurine',
    app_rate_11: '20.0%',
    avg_round_11: 0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'yukong',
    app: 0.01,
    char_1: 'jade',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'tribbie',
    app_rate_2: '50.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'aventurine',
    app_rate_3: '50.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'the-herta',
    app_rate_4: '50.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'huohuo',
    app_rate_5: '50.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'luka',
    app: 0.01,
    char_1: 'lingsha',
    app_rate_1: '200.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'tingyun-fugue',
    app_rate_2: '100.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'trailblazer-harmony',
    app_rate_3: '100.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: '-',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '-',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'arlan',
    app: 0.01,
    char_1: 'castorice',
    app_rate_1: '100.0%',
    avg_round_1: 28120,
    app_flat_1: 1,
    char_2: 'mydei',
    app_rate_2: '50.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'luocha',
    app_rate_3: '50.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'tribbie',
    app_rate_4: '50.0%',
    avg_round_4: 28120,
    app_flat_4: 1,
    char_5: 'gallagher',
    app_rate_5: '50.0%',
    avg_round_5: 28120,
    app_flat_5: 1,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'trailblazer-preservation',
    app: 0.01,
    char_1: 'pela',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'acheron',
    app_rate_2: '50.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'bronya',
    app_rate_3: '50.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'jingliu',
    app_rate_4: '50.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'tribbie',
    app_rate_5: '50.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'hook',
    app: 0.01,
    char_1: 'jiaoqiu',
    app_rate_1: '50.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'robin',
    app_rate_2: '50.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'huohuo',
    app_rate_3: '50.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'sparkle',
    app_rate_4: '50.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'tribbie',
    app_rate_5: '50.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'fu-xuan',
    app_rate_6: '50.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'moze',
    app: 0.01,
    char_1: 'dr-ratio',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'robin',
    app_rate_2: '100.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'gallagher',
    app_rate_3: '100.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: '-',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '-',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'trailblazer-destruction',
    app: 0.01,
    char_1: 'acheron',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'jiaoqiu',
    app_rate_2: '100.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'aventurine',
    app_rate_3: '100.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: '-',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '-',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'misha',
    app: 0.01,
    char_1: 'jing-yuan',
    app_rate_1: '100.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'sunday',
    app_rate_2: '100.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'aventurine',
    app_rate_3: '100.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: '-',
    app_rate_4: '0.00%',
    avg_round_4: 0.0,
    app_flat_4: 0,
    char_5: '-',
    app_rate_5: '0.00%',
    avg_round_5: 0.0,
    app_flat_5: 0,
    char_6: '-',
    app_rate_6: '0.00%',
    avg_round_6: 0.0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  },
  {
    char: 'sampo',
    app: 0.01,
    char_1: 'black-swan',
    app_rate_1: '50.0%',
    avg_round_1: 0,
    app_flat_1: 0,
    char_2: 'tribbie',
    app_rate_2: '50.0%',
    avg_round_2: 0,
    app_flat_2: 0,
    char_3: 'aventurine',
    app_rate_3: '50.0%',
    avg_round_3: 0,
    app_flat_3: 0,
    char_4: 'acheron',
    app_rate_4: '50.0%',
    avg_round_4: 0,
    app_flat_4: 0,
    char_5: 'himeko',
    app_rate_5: '50.0%',
    avg_round_5: 0,
    app_flat_5: 0,
    char_6: 'kafka',
    app_rate_6: '50.0%',
    avg_round_6: 0,
    app_flat_6: 0,
    char_7: '-',
    app_rate_7: '0.00%',
    avg_round_7: 0.0,
    app_flat_7: 0,
    char_8: '-',
    app_rate_8: '0.00%',
    avg_round_8: 0.0,
    app_flat_8: 0,
    char_9: '-',
    app_rate_9: '0.00%',
    avg_round_9: 0.0,
    app_flat_9: 0,
    char_10: '-',
    app_rate_10: '0.00%',
    avg_round_10: 0.0,
    app_flat_10: 0,
    char_11: '-',
    app_rate_11: '0.00%',
    avg_round_11: 0.0,
    app_flat_11: 0,
    char_12: '-',
    app_rate_12: '0.00%',
    avg_round_12: 0.0,
    app_flat_12: 0,
    char_13: '-',
    app_rate_13: '0.00%',
    avg_round_13: 0.0,
    app_flat_13: 0,
    char_14: '-',
    app_rate_14: '0.00%',
    avg_round_14: 0.0,
    app_flat_14: 0,
    char_15: '-',
    app_rate_15: '0.00%',
    avg_round_15: 0.0,
    app_flat_15: 0,
    char_16: '-',
    app_rate_16: '0.00%',
    avg_round_16: 0.0,
    app_flat_16: 0,
    char_17: '-',
    app_rate_17: '0.00%',
    avg_round_17: 0.0,
    app_flat_17: 0,
    char_18: '-',
    app_rate_18: '0.00%',
    avg_round_18: 0.0,
    app_flat_18: 0,
    char_19: '-',
    app_rate_19: '0.00%',
    avg_round_19: 0.0,
    app_flat_19: 0,
    char_20: '-',
    app_rate_20: '0.00%',
    avg_round_20: 0.0,
    app_flat_20: 0,
    char_21: '-',
    app_rate_21: '0.00%',
    avg_round_21: 0.0,
    app_flat_21: 0,
    char_22: '-',
    app_rate_22: '0.00%',
    avg_round_22: 0.0,
    app_flat_22: 0,
    char_23: '-',
    app_rate_23: '0.00%',
    avg_round_23: 0.0,
    app_flat_23: 0,
    char_24: '-',
    app_rate_24: '0.00%',
    avg_round_24: 0.0,
    app_flat_24: 0,
    char_25: '-',
    app_rate_25: '0.00%',
    avg_round_25: 0.0,
    app_flat_25: 0,
    char_26: '-',
    app_rate_26: '0.00%',
    avg_round_26: 0.0,
    app_flat_26: 0,
    char_27: '-',
    app_rate_27: '0.00%',
    avg_round_27: 0.0,
    app_flat_27: 0,
    char_28: '-',
    app_rate_28: '0.00%',
    avg_round_28: 0.0,
    app_flat_28: 0,
    char_29: '-',
    app_rate_29: '0.00%',
    avg_round_29: 0.0,
    app_flat_29: 0,
    char_30: '-',
    app_rate_30: '0.00%',
    avg_round_30: 0.0,
    app_flat_30: 0
  }
];
